<template>
  <div class="tcla" dir="rtl">
    <!-- Header -->
    <div class="tcla-header">
      <div class="tcla-header__top">
        <div class="tcla-header__info">
          <h1 class="tcla-header__title">
            <span class="tcla-header__icon">🔗</span>
            تحلیل خوشه‌های لینک‌دهی داخلی
          </h1>
          <p class="tcla-header__subtitle">نمایش صفحات بر اساس سلسله‌مراتب کلمات کلیدی و روابط لینک‌دهی</p>
        </div>
        <div class="tcla-header__badges">
          <span class="tcla-badge tcla-badge--blue">{{ totalClusters }} خوشه</span>
          <span class="tcla-badge tcla-badge--green">{{ totalLinkedPages }} صفحه</span>
          <span class="tcla-badge" :class="overallBadgeClass">{{ overallStatusText }}</span>
          <span class="tcla-badge" @click="copy_data()" :class="overallBadgeClass"><CIcon name="cil-clone" /></span>
        </div>
      </div>

      <!-- Stats -->
      <div class="tcla-stats">
        <div class="tcla-stat tcla-stat--success">
          <div class="tcla-stat__value">{{ correctLinks }}</div>
          <div class="tcla-stat__label">لینک‌های صحیح</div>
          <div class="tcla-stat__bar">
            <div class="tcla-stat__bar-fill" :style="{ width: correctPercent + '%' }"></div>
          </div>
        </div>
        <div class="tcla-stat tcla-stat--danger">
          <div class="tcla-stat__value">{{ incorrectLinks }}</div>
          <div class="tcla-stat__label">لینک‌های اشتباه</div>
          <div class="tcla-stat__bar">
            <div class="tcla-stat__bar-fill" :style="{ width: incorrectPercent + '%' }"></div>
          </div>
        </div>
        <div class="tcla-stat tcla-stat--warning">
          <div class="tcla-stat__value">{{ missingLinks }}</div>
          <div class="tcla-stat__label">لینک‌های از دست رفته</div>
          <div class="tcla-stat__bar">
            <div class="tcla-stat__bar-fill" :style="{ width: missingPercent + '%' }"></div>
          </div>
        </div>
        <div class="tcla-stat tcla-stat--neutral">
          <div class="tcla-stat__value">{{ totalInternalLinks }}</div>
          <div class="tcla-stat__label">کل لینک‌های داخلی</div>
          <div class="tcla-stat__bar">
            <div class="tcla-stat__bar-fill tcla-stat__bar-fill--full"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tab Navigation (v2.0) -->
    <div class="tcla-tabs">
      <button
          v-for="tab in tabList"
          :key="tab.key"
          class="tcla-tab"
          :class="{ 'tcla-tab--active': activeTab === tab.key }"
          @click="activeTab = tab.key"
      >
        <span class="tcla-tab__icon">{{ tab.icon }}</span>
        {{ tab.label }}
        <span v-if="tab.badge !== undefined && tab.badge !== null" class="tcla-tab__badge">{{ tab.badge }}</span>
      </button>
    </div>

    <!-- ============================================================
         TAB: SMART SEO DASHBOARD (v2.0)
         ============================================================ -->
    <div v-show="activeTab === 'dashboard'" class="tcla-dashboard">
      <div class="tcla-cards-grid">
        <div class="tcla-card">
          <div class="tcla-card__icon">🧭</div>
          <div class="tcla-card__value">{{ dashboardStats.avgTopicalAuthority }}</div>
          <div class="tcla-card__label">اقتدار موضوعی میانگین</div>
        </div>
        <div class="tcla-card">
          <div class="tcla-card__icon">🏆</div>
          <div class="tcla-card__value">{{ dashboardStats.avgPageRank }}</div>
          <div class="tcla-card__label">Internal PageRank میانگین</div>
        </div>
        <div class="tcla-card">
          <div class="tcla-card__icon">🧩</div>
          <div class="tcla-card__value">{{ hubs.length }}</div>
          <div class="tcla-card__label">صفحات Hub</div>
        </div>
        <div class="tcla-card tcla-card--warn">
          <div class="tcla-card__icon">⚠️</div>
          <div class="tcla-card__value">{{ dashboardStats.weakPagesCount }}</div>
          <div class="tcla-card__label">صفحات ضعیف</div>
        </div>
        <div class="tcla-card tcla-card--danger">
          <div class="tcla-card__icon">🏝️</div>
          <div class="tcla-card__value">{{ orphans.length }}</div>
          <div class="tcla-card__label">صفحات یتیم</div>
        </div>
        <div class="tcla-card tcla-card--danger">
          <div class="tcla-card__icon">🚧</div>
          <div class="tcla-card__value">{{ deadEnds.length }}</div>
          <div class="tcla-card__label">صفحات بن‌بست</div>
        </div>
        <div class="tcla-card">
          <div class="tcla-card__icon">🔍</div>
          <div class="tcla-card__value">{{ keywordGaps.length }}</div>
          <div class="tcla-card__label">شکاف کلمه کلیدی</div>
        </div>
        <div class="tcla-card">
          <div class="tcla-card__icon">⚓</div>
          <div class="tcla-card__value">{{ dashboardStats.avgAnchorDiversity }}</div>
          <div class="tcla-card__label">تنوع انکر میانگین</div>
        </div>
        <div class="tcla-card">
          <div class="tcla-card__icon">📚</div>
          <div class="tcla-card__value">{{ dashboardStats.avgClusterCoverage }}%</div>
          <div class="tcla-card__label">پوشش خوشه‌ها</div>
        </div>
        <div class="tcla-card">
          <div class="tcla-card__icon">🔗</div>
          <div class="tcla-card__value">{{ missingLinkSuggestions.length }}</div>
          <div class="tcla-card__label">لینک‌های از دست رفته (کل)</div>
        </div>
        <div class="tcla-card">
          <div class="tcla-card__icon">📝</div>
          <div class="tcla-card__value">{{ keywordGaps.length }}</div>
          <div class="tcla-card__label">مقالات پیشنهادی</div>
        </div>
        <div class="tcla-card">
          <div class="tcla-card__icon">⚖️</div>
          <div class="tcla-card__value">{{ dashboardStats.avgLinkEquity }}</div>
          <div class="tcla-card__label">میانگین ارزش لینک داخلی</div>
        </div>
      </div>

      <!-- Top pages by SEO score -->
      <div class="tcla-panel">
        <h3 class="tcla-panel__title">🏅 صفحات برتر بر اساس امتیاز SEO</h3>
        <div class="tcla-score-table">
          <div class="tcla-score-row tcla-score-row--head">
            <span>صفحه</span><span>SEO</span><span>لینک‌دهی</span><span>اقتدار</span><span>موضوعی</span><span>Hub</span><span>انکر</span>
          </div>
          <div v-for="row in topScoredPages" :key="row.url" class="tcla-score-row">
            <span class="tcla-score-row__title">{{ row.title }}</span>
            <span class="tcla-score-pill" :class="scoreClass(row.scores.seoScore)">{{ row.scores.seoScore }}</span>
            <span>{{ row.scores.internalLinkingScore }}</span>
            <span>{{ row.scores.authorityScore }}</span>
            <span>{{ row.scores.topicalScore }}</span>
            <span>{{ row.scores.hubScore }}</span>
            <span>{{ row.scores.anchorScore }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- ============================================================
         TAB: HUB & SPOKE
         ============================================================ -->
    <div v-show="activeTab === 'hubspoke'" class="tcla-section-tab">
      <div class="tcla-panel">
        <h3 class="tcla-panel__title">🧭 صفحات Hub شناسایی‌شده</h3>
        <div v-if="hubs.length === 0" class="tcla-empty-inline">هیچ صفحه Hub مشخصی شناسایی نشد.</div>
        <div v-for="hub in hubs" :key="hub.url" class="tcla-hub-card">
          <div class="tcla-hub-card__top">
            <div>
              <strong>{{ hub.title }}</strong>
              <span class="tcla-tag tcla-tag--blue">{{ hub.cluster }}</span>
              <span v-if="hub.isDeadEndHub" class="tcla-tag tcla-tag--err">Hub بن‌بست! هیچ لینک خروجی ندارد</span>
            </div>
            <button class="tcla-btn tcla-btn--outline" @click="open_edit_blog(getSourceByUrl(hub.url))">ویرایش</button>
          </div>
          <div class="tcla-hub-card__meta">
            <span>امتیاز Hub: <strong>{{ hub.hubScore }}</strong></span>
            <span class="tcla-cluster__meta-sep">·</span>
            <span>خروجی مورد انتظار: {{ hub.expectedOutgoing }}</span>
            <span class="tcla-cluster__meta-sep">·</span>
            <span>خروجی واقعی: {{ hub.actualOutgoing }}</span>
            <span class="tcla-cluster__meta-sep">·</span>
            <span>لینک‌های خروجی مفقود: {{ hub.missingOutgoing.length }}</span>
          </div>
          <div v-if="hub.missingOutgoing.length" class="tcla-chip-list">
            <span v-for="m in hub.missingOutgoing" :key="m.url" class="tcla-word-chip">{{ m.title }}</span>
          </div>
        </div>
      </div>

      <div class="tcla-panel">
        <h3 class="tcla-panel__title">🔗 صفحات Spoke و لینک‌های مفقود</h3>
        <div v-if="spokes.length === 0" class="tcla-empty-inline">همه صفحات Spoke به‌درستی لینک شده‌اند.</div>
        <div v-for="spoke in spokes" :key="spoke.url" class="tcla-hub-card">
          <div class="tcla-hub-card__top">
            <div><strong>{{ spoke.title }}</strong> <span class="tcla-tag tcla-tag--blue">{{ spoke.cluster }}</span></div>
            <button class="tcla-btn tcla-btn--outline" @click="open_edit_blog(spoke.source)">ویرایش</button>
          </div>
          <div class="tcla-hub-card__meta">
            <span v-if="spoke.missingParentLink" class="tcla-tag tcla-tag--err">لینک والد مفقود</span>
            <span v-if="spoke.missingHubLink" class="tcla-tag tcla-tag--err">لینک Hub مفقود</span>
            <span v-if="spoke.missingSiblingLinks.length" class="tcla-tag tcla-tag--warn">{{ spoke.missingSiblingLinks.length }} لینک خواهر/برادر مفقود</span>
          </div>
        </div>
      </div>
    </div>

    <!-- ============================================================
         TAB: TOPICAL AUTHORITY
         ============================================================ -->
    <div v-show="activeTab === 'topical'" class="tcla-section-tab">
      <div class="tcla-panel" v-for="cluster in topicalClusters" :key="cluster.name">
        <div class="tcla-cluster-authority__head">
          <h3 class="tcla-panel__title">📁 {{ cluster.name }}</h3>
          <div class="tcla-authority-badge" :class="scoreClass(cluster.avgAuthority)">اقتدار: {{ cluster.avgAuthority }}</div>
        </div>
        <div class="tcla-score-bar-track">
          <div class="tcla-score-bar-fill" :class="scoreClass(cluster.avgAuthority)" :style="{ width: cluster.avgAuthority + '%' }"></div>
        </div>
        <div class="tcla-hub-card__meta">
          <span>{{ cluster.pageCount }} صفحه</span>
          <span class="tcla-cluster__meta-sep">·</span>
          <span>{{ cluster.orphanCount }} یتیم</span>
          <span class="tcla-cluster__meta-sep">·</span>
          <span>{{ cluster.deadEndCount }} بن‌بست</span>
          <span class="tcla-cluster__meta-sep">·</span>
          <span>سلامت خوشه: {{ cluster.healthScore }}</span>
        </div>
      </div>
    </div>

    <!-- ============================================================
         TAB: ORPHAN & DEAD-END PAGES
         ============================================================ -->
    <div v-show="activeTab === 'orphans'" class="tcla-section-tab">
      <div class="tcla-panel">
        <h3 class="tcla-panel__title tcla-section__title--err">🏝️ صفحات یتیم (Orphan)</h3>
        <div v-if="orphans.length === 0" class="tcla-empty-inline">هیچ صفحه یتیمی یافت نشد 🎉</div>
        <div v-for="o in orphans" :key="o.url" class="tcla-linked tcla-linked--err">
          <div class="tcla-linked__left">
            <span class="tcla-linked__status-icon">✕</span>
            <div class="tcla-linked__info">
              <span class="tcla-linked__title">{{ o.title }}
                <CButton @click="open_edit_blog(o.source)" size="sm" color="secondary">ویرایش</CButton>
              </span>
              <span class="tcla-linked__anchor">{{ o.severity }} · لینک ورودی: {{ o.incomingCount }} · اقتدار: {{ o.authority }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="tcla-panel">
        <h3 class="tcla-panel__title tcla-section__title--warn">🚧 صفحات بن‌بست (Dead End)</h3>
        <div v-if="deadEnds.length === 0" class="tcla-empty-inline">هیچ صفحه بن‌بستی یافت نشد 🎉</div>
        <div v-for="d in deadEnds" :key="d.url" class="tcla-linked tcla-linked--warn">
          <div class="tcla-linked__left">
            <span class="tcla-linked__status-icon">⤳</span>
            <div class="tcla-linked__info">
              <span class="tcla-linked__title">{{ d.title }}
                <CButton @click="open_edit_blog(d.source)" size="sm" color="secondary">ویرایش</CButton>
              </span>
              <span class="tcla-linked__anchor">هیچ لینک خروجی ندارد · لینک ورودی: {{ d.incomingCount }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ============================================================
         TAB: ANCHOR DIVERSITY
         ============================================================ -->
    <div v-show="activeTab === 'anchors'" class="tcla-section-tab">
      <div class="tcla-panel">
        <h3 class="tcla-panel__title">⚓ تحلیل تنوع انکرتکست</h3>
        <div v-if="anchorAnalysis.length === 0" class="tcla-empty-inline">لینک ورودی‌ای برای تحلیل یافت نشد.</div>
        <div v-for="a in anchorAnalysis" :key="a.url" class="tcla-hub-card">
          <div class="tcla-hub-card__top">
            <div>
              <strong>{{ a.title }}</strong>
              <span v-if="a.overOptimized" class="tcla-tag tcla-tag--err">بیش‌بهینه‌سازی شده</span>
              <span v-if="a.lowDiversity" class="tcla-tag tcla-tag--warn">تنوع پایین</span>
            </div>
            <span class="tcla-score-pill" :class="scoreClass(a.diversityScore)">تنوع: {{ a.diversityScore }}</span>
          </div>
          <div class="tcla-hub-card__meta">
            <span>پرتکرارترین انکر: «{{ a.topAnchor }}» ({{ a.topAnchorRatio }}٪)</span>
            <span class="tcla-cluster__meta-sep">·</span>
            <span>مجموع لینک‌های ورودی: {{ a.totalAnchors }}</span>
          </div>
          <div v-if="a.duplicates.length" class="tcla-chip-list">
            <span v-for="(d, i) in a.duplicates" :key="i" class="tcla-word-chip">{{ d.text }} × {{ d.count }}</span>
          </div>
          <div v-if="a.suggestions.length" class="tcla-suggestion-box">
            <div class="tcla-suggestion-box__header"><span>💡</span> پیشنهاد انکرتکست جایگزین</div>
            <div class="tcla-suggestion-box__body">
              <div class="tcla-chip-list">
                <span v-for="(s, i) in a.suggestions" :key="i" class="tcla-tag tcla-tag--green">{{ s }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ============================================================
         TAB: LINK OPPORTUNITIES / MISSING LINKS (expanded)
         ============================================================ -->
    <div v-show="activeTab === 'opportunities'" class="tcla-section-tab">
      <div class="tcla-panel">
        <h3 class="tcla-panel__title">💡 فرصت‌های لینک‌سازی داخلی</h3>
        <div v-if="linkOpportunities.length === 0" class="tcla-empty-inline">فرصت لینک‌سازی جدیدی یافت نشد.</div>
        <div v-for="(op, i) in linkOpportunities" :key="i" class="tcla-missing">
          <div class="tcla-missing__top">
            <div class="tcla-missing__info">
              <span class="tcla-missing__reason">{{ op.reason }}</span>
              <div class="tcla-missing__tags">
                <span class="tcla-tag tcla-tag--blue">لنگر: "{{ op.suggestedAnchor }}"</span>
                <span class="tcla-tag tcla-tag--green">{{ op.typeLabel }}</span>
                <span v-if="op.similarity !== null" class="tcla-tag tcla-tag--purple">شباهت معنایی {{ op.similarity }}٪</span>
              </div>
            </div>
            <button class="tcla-btn tcla-btn--outline" @click="showOpportunityDetail(op)">مشاهده جزئیات</button>
            <button class="tcla-btn tcla-btn--outline" @click="open_edit_blog(op.source)">ویرایش مقاله</button>
          </div>
        </div>
      </div>
    </div>

    <!-- ============================================================
         TAB: KEYWORD GAP
         ============================================================ -->
    <div v-show="activeTab === 'gaps'" class="tcla-section-tab">
      <div class="tcla-panel">
        <h3 class="tcla-panel__title">🔍 شکاف‌های محتوایی و مقالات پیشنهادی</h3>
        <div v-if="keywordGaps.length === 0" class="tcla-empty-inline">شکاف محتوایی مشخصی یافت نشد.</div>
        <div v-for="(gap, i) in keywordGaps" :key="i" class="tcla-hub-card">
          <div class="tcla-hub-card__top">
            <div>
              <strong>{{ gap.suggestedTitle }}</strong>
              <span class="tcla-tag tcla-tag--blue">هاب مرتبط: {{ gap.relatedHub }}</span>
            </div>
            <button class="tcla-btn tcla-btn--primary tcla-btn--sm" @click="copyText(gap.suggestedTitle, 'عنوان کپی شد')">کپی عنوان</button>
          </div>
          <div class="tcla-hub-card__meta">
            <span>کلمه کلیدی هدف: {{ gap.targetKeyword }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- ============================================================
         TAB: CLUSTER HEALTH
         ============================================================ -->
    <div v-show="activeTab === 'health'" class="tcla-section-tab">
      <div class="tcla-panel">
        <h3 class="tcla-panel__title">🩺 سلامت خوشه‌های موضوعی</h3>
        <div v-for="c in clusterHealth" :key="c.name" class="tcla-hub-card">
          <div class="tcla-hub-card__top">
            <strong>{{ c.name }}</strong>
            <span class="tcla-score-pill" :class="scoreClass(c.coverage)">پوشش: {{ c.coverage }}٪</span>
          </div>
          <div class="tcla-hub-card__meta">
            <span>اقتدار: {{ c.authority }}</span>
            <span class="tcla-cluster__meta-sep">·</span>
            <span>{{ c.pageCount }} صفحه</span>
            <span class="tcla-cluster__meta-sep">·</span>
            <span>{{ c.missingPagesCount }} صفحه مفقود</span>
            <span class="tcla-cluster__meta-sep">·</span>
            <span>{{ c.missingLinksCount }} لینک مفقود</span>
            <span class="tcla-cluster__meta-sep">·</span>
            <span>{{ c.weakPagesCount }} صفحه ضعیف</span>
          </div>
        </div>
      </div>
    </div>

    <!-- ============================================================
         TAB: VISUAL GRAPH
         ============================================================ -->
    <div v-show="activeTab === 'graph'" class="tcla-section-tab">
      <div class="tcla-panel" v-for="g in graphLayouts" :key="g.clusterName">
        <h3 class="tcla-panel__title">🕸️ نقشه لینک‌دهی خوشه «{{ g.clusterName }}»</h3>
        <svg :viewBox="'0 0 ' + g.width + ' ' + g.height" class="tcla-graph-svg">
          <line v-for="(e, i) in g.edges" :key="'e' + i"
                :x1="e.x1" :y1="e.y1" :x2="e.x2" :y2="e.y2"
                class="tcla-graph-edge" :class="{ 'tcla-graph-edge--missing': e.missing }" />
          <g v-for="n in g.nodes" :key="n.url">
            <circle :cx="n.x" :cy="n.y" :r="n.r" class="tcla-graph-node" :class="'tcla-graph-node--' + n.type" />
            <text :x="n.x" :y="n.y + n.r + 14" class="tcla-graph-label">{{ n.shortTitle }}</text>
          </g>
        </svg>
      </div>
      <div class="tcla-panel">
        <div class="tcla-graph-legend">
          <span class="tcla-legend-item"><i class="tcla-graph-node tcla-graph-node--hub"></i> Hub</span>
          <span class="tcla-legend-item"><i class="tcla-graph-node tcla-graph-node--spoke"></i> Spoke</span>
          <span class="tcla-legend-item"><i class="tcla-graph-node tcla-graph-node--sibling"></i> Sibling</span>
          <span class="tcla-legend-item"><i class="tcla-graph-node tcla-graph-node--orphan"></i> Orphan</span>
          <span class="tcla-legend-item"><i class="tcla-graph-node tcla-graph-node--deadend"></i> Dead End</span>
        </div>
      </div>
    </div>

    <!-- ============================================================
         TAB: LEGACY KEYWORD-COUNT CLUSTERS (v1.0 — preserved)
         ============================================================ -->
    <div v-show="activeTab === 'legacy'">
      <!-- Filters -->
      <div class="tcla-filters">
        <div class="tcla-filter">
          <label class="tcla-filter__label">مرتب‌سازی</label>
          <select class="tcla-filter__select" v-model="sortBy">
            <option v-for="opt in sortOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
          </select>
        </div>
        <div class="tcla-filter">
          <label class="tcla-filter__label">وضعیت</label>
          <select class="tcla-filter__select" v-model="filterStatus">
            <option v-for="opt in filterOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
          </select>
        </div>
        <div class="tcla-filter tcla-filter--search">
          <label class="tcla-filter__label">جستجو</label>
          <div class="tcla-search">
            <svg class="tcla-search__icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input class="tcla-search__input" type="text" placeholder="نام صفحه را وارد کنید..." v-model="searchQuery" />
          </div>
        </div>
      </div>

      <!-- Empty state -->
      <div v-if="filteredClusters.length === 0" class="tcla-empty">
        <div class="tcla-empty__icon">📭</div>
        <p class="tcla-empty__text">هیچ داده‌ای برای نمایش وجود ندارد</p>
        <p class="tcla-empty__hint" v-if="searchQuery || filterStatus !== 'all'">فیلترها را تغییر دهید یا جستجو را پاک کنید</p>
      </div>

      <!-- Clusters -->
      <div v-else class="tcla-clusters">
        <div
            v-for="(cluster, index) in filteredClusters"
            :key="index"
            class="tcla-cluster"
            :class="'tcla-cluster--' + cluster.health"
            :style="{ animationDelay: index * 0.06 + 's' }"
        >
          <!-- Cluster Header -->
          <div class="tcla-cluster__header" @click="toggleCluster(index)">
            <div class="tcla-cluster__header-right">
              <span class="tcla-cluster__folder">📁</span>
              <div>
                <h3 class="tcla-cluster__title">
                  {{ cluster.title }}
                  <span class="tcla-cluster__keyword-tag">({{ cluster.keyword }})</span>
                  <CButton @click="open_edit_blog(cluster.source)" color="warning">
                    ویرایش
                  </CButton>
                </h3>
                <div class="tcla-cluster__meta">
                  <span class="tcla-cluster__health-dot" :class="'tcla-cluster__health-dot--' + cluster.health"></span>
                  {{ getHealthLabel(cluster.health) }}
                  <span class="tcla-cluster__meta-sep">·</span>
                  {{ cluster.keywordCount }} کلمه کلیدی
                  <span class="tcla-cluster__meta-sep">·</span>
                  {{ cluster.linkedPages.length }} صفحه لینک‌دهنده
                  <span class="tcla-cluster__meta-sep">·</span>
                  {{ cluster.incomingLinks }} ورودی / {{ cluster.outgoingLinks }} خروجی
                </div>
              </div>
            </div>
            <svg
                class="tcla-cluster__chevron"
                :class="{ 'tcla-cluster__chevron--open': openClusters[index] }"
                width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            >
              <polyline points="6 9 12 15 18 9"/>
            </svg>
          </div>

          <!-- Cluster Body -->
          <div v-show="openClusters[index]" class="tcla-cluster__body">
            <!-- Description Rule -->
            <div class="tcla-rule">
              <span class="tcla-rule__icon">📐</span>
              <span class="tcla-rule__text">
              صفحات با کلمات کلیدی بیشتر ({{ cluster.keywordCount + 1 }}+ کلمه) باید به این صفحه ({{ cluster.keywordCount }} کلمه) لینک دهند
            </span>
              <span v-if="cluster.health === 'healthy'" class="tcla-rule__check">✓</span>
              <span v-else class="tcla-rule__warn">!</span>
            </div>

            <!-- Linked Pages -->
            <div v-if="cluster.linkedPages.length > 0" class="tcla-section">
              <h4 class="tcla-section__title">صفحات لینک‌دهنده به این خوشه</h4>
              <div class="tcla-linked-list">
                <div
                    v-for="(page, pidx) in cluster.linkedPages"
                    :key="pidx"
                    class="tcla-linked"
                    :class="{
                  'tcla-linked--ok': page.isCorrect && page.levelDifference === 1,
                  'tcla-linked--warn': page.isCorrect && page.levelDifference > 1,
                  'tcla-linked--err': !page.isCorrect
                }"
                >
                  <div class="tcla-linked__left">
                  <span class="tcla-linked__status-icon">
                    <template v-if="page.isCorrect && page.levelDifference === 1">✓</template>
                    <template v-else-if="page.isCorrect && page.levelDifference > 1">⤳</template>
                    <template v-else>✕</template>
                  </span>
                    <div class="tcla-linked__info">
                    <span class="tcla-linked__title">{{ page.title }}
                    <CButton @click="open_edit_blog(page.source)" size="sm" color="secondary">ویرایش</CButton></span>
                      <span class="tcla-linked__anchor">لنگر: "{{ page.anchorText }}"</span>
                    </div>
                  </div>
                  <div class="tcla-linked__right">
                    <span class="tcla-linked__kw-count">{{ page.keywordCount }} کلمه</span>
                    <span class="tcla-linked__direction">{{ page.keywordCount }} → {{ cluster.keywordCount }}</span>
                    <span v-if="page.isCorrect && page.levelDifference === 1" class="tcla-tag tcla-tag--ok">صحیح</span>
                    <span v-else-if="page.isCorrect && page.levelDifference > 1" class="tcla-tag tcla-tag--warn">پرش {{ page.levelDifference }} سطحی</span>
                    <span v-else class="tcla-tag tcla-tag--err">اشتباه</span>
                    <button
                        v-if="!page.isCorrect || page.levelDifference > 1"
                        class="tcla-btn-link"
                        @click.stop="showSuggestion(page, cluster)"
                    >
                      راه حل
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Errors -->
            <div v-if="cluster.errors && cluster.errors.length > 0" class="tcla-section">
              <h4 class="tcla-section__title tcla-section__title--err">خطاها</h4>
              <div class="tcla-errors">
                <div v-for="(error, eidx) in cluster.errors" :key="eidx" class="tcla-error-item">
                  {{ error }}
                </div>
              </div>
            </div>

            <!-- Missing Links -->
            <div v-if="cluster.missingLinks && cluster.missingLinks.length > 0" class="tcla-section">
              <h4 class="tcla-section__title tcla-section__title--warn">لینک‌های از دست رفته</h4>
              <div class="tcla-missing-list">
                <div
                    v-for="(missing, midx) in cluster.missingLinks"
                    :key="midx"
                    class="tcla-missing"
                >
                  <div class="tcla-missing__top">
                    <div class="tcla-missing__info">
                      <span class="tcla-missing__reason">{{ missing.reason }}</span>
                      <div class="tcla-missing__tags">
                        <span class="tcla-tag tcla-tag--blue">لنگر: "{{ missing.suggestedAnchor }}"</span>
                        <span class="tcla-tag tcla-tag--green">{{ missing.relationType }}</span>
                      </div>
                    </div>
                    <button class="tcla-btn tcla-btn--outline" @click="showMissingSuggestion(missing)">
                      مشاهده جزئیات
                    </button>
                    <button class="tcla-btn tcla-btn--outline" @click="open_edit_blog(missing.source)">
                      ویرایش مقاله
                    </button>
                  </div>

                  <!-- Common words -->
                  <div v-if="missing.commonWords && missing.commonWords.length > 0" class="tcla-common-words">
                    <span class="tcla-common-words__label">کلمات مشترک:</span>
                    <span v-for="(word, widx) in missing.commonWords" :key="widx" class="tcla-word-chip">{{ word }}</span>
                  </div>

                  <!-- Suggestion Box -->
                  <div class="tcla-suggestion-box">
                    <div class="tcla-suggestion-box__header">
                      <span>💡</span> پیشنهاد لینک‌سازی
                    </div>
                    <div class="tcla-suggestion-box__body">
                      <p>
                        از صفحه <strong>{{ missing.title }}</strong>
                        با لنگر <code>"{{ missing.suggestedAnchor }}"</code>
                        به صفحه <strong>{{ missing.targetTitle }}</strong> لینک دهید.
                      </p>
                      <p class="tcla-suggestion-box__example">
                        مثال: برای اطلاعات بیشتر در مورد <a>{{ missing.suggestedAnchor }}</a>، مقاله جامع ما را مطالعه کنید.
                      </p>
                      <button class="tcla-btn tcla-btn--primary tcla-btn--sm" @click="copyLinkSuggestion(missing)">
                        کپی متن لینک
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /TAB: LEGACY -->

    <!-- Modal: Link Opportunity Detail (v2.0) -->
    <div v-if="showOpportunityModal" class="tcla-modal-overlay" @click.self="showOpportunityModal = false">
      <div class="tcla-modal">
        <div class="tcla-modal__header">
          <h3>🔗 جزئیات فرصت لینک‌سازی</h3>
          <button class="tcla-modal__close" @click="showOpportunityModal = false">✕</button>
        </div>
        <div class="tcla-modal__body" v-if="selectedOpportunity">
          <div class="tcla-modal__section">
            <h4>صفحه مبدأ</h4>
            <p><strong>{{ selectedOpportunity.sourceTitle }}</strong></p>
          </div>
          <div class="tcla-modal__section">
            <h4>صفحه مقصد</h4>
            <p><strong>{{ selectedOpportunity.targetTitle }}</strong></p>
          </div>
          <div class="tcla-modal__section">
            <h4>نوع رابطه</h4>
            <p class="tcla-modal__solution">{{ selectedOpportunity.typeLabel }}</p>
          </div>
          <div class="tcla-modal__section">
            <h4>دلیل پیشنهاد</h4>
            <p class="tcla-modal__warn">{{ selectedOpportunity.reason }}</p>
          </div>
          <div class="tcla-modal__section">
            <h4>محل پیشنهادی درج لینک</h4>
            <p>{{ selectedOpportunity.insertionPoint }}</p>
          </div>
          <div class="tcla-modal__section">
            <h4>لنگر پیشنهادی</h4>
            <div class="tcla-modal__code-block">{{ selectedOpportunity.suggestedAnchor }}</div>
          </div>
          <div class="tcla-modal__section">
            <h4>جمله پیشنهادی</h4>
            <div class="tcla-modal__highlight tcla-modal__highlight--blue">{{ selectedOpportunity.suggestedSentence }}</div>
          </div>
          <div class="tcla-modal__section">
            <h4>کد HTML پیشنهادی</h4>
            <div class="tcla-modal__code-block tcla-modal__code-block--dark">
              &lt;a href="{{ selectedOpportunity.targetUrl }}"&gt;{{ selectedOpportunity.suggestedAnchor }}&lt;/a&gt;
            </div>
          </div>
        </div>
        <div class="tcla-modal__footer">
          <button class="tcla-btn tcla-btn--outline" @click="showOpportunityModal = false">بستن</button>
          <button class="tcla-btn tcla-btn--primary" @click="copyOpportunitySuggestion">کپی متن</button>
        </div>
      </div>
    </div>

    <!-- Modal: Suggestion -->
    <div v-if="showModal" class="tcla-modal-overlay" @click.self="showModal = false">
      <div class="tcla-modal">
        <div class="tcla-modal__header">
          <h3>💡 راه حل پیشنهادی</h3>
          <button class="tcla-modal__close" @click="showModal = false">✕</button>
        </div>
        <div class="tcla-modal__body" v-if="selectedSuggestion">
          <div class="tcla-modal__section">
            <h4>مشکل</h4>
            <p class="tcla-modal__problem">{{ selectedSuggestion.problem }}</p>
          </div>
          <div class="tcla-modal__section">
            <h4>راه حل</h4>
            <p class="tcla-modal__solution">{{ selectedSuggestion.solution }}</p>
          </div>
          <div class="tcla-modal__section">
            <h4>لنگر پیشنهادی</h4>
            <div class="tcla-modal__code-block">{{ selectedSuggestion.suggestedAnchor }}</div>
          </div>
          <div class="tcla-modal__section">
            <h4>مثال</h4>
            <div class="tcla-modal__example-block">{{ selectedSuggestion.example }}</div>
          </div>
        </div>
        <div class="tcla-modal__footer">
          <button class="tcla-btn tcla-btn--outline" @click="showModal = false">بستن</button>
        </div>
      </div>
    </div>

    <!-- Modal: Missing -->
    <div v-if="showMissingModal" class="tcla-modal-overlay" @click.self="showMissingModal = false">
      <div class="tcla-modal">
        <div class="tcla-modal__header">
          <h3>📝 جزئیات لینک از دست رفته</h3>
          <button class="tcla-modal__close" @click="showMissingModal = false">✕</button>
        </div>
        <div class="tcla-modal__body" v-if="selectedMissing">
          <div class="tcla-modal__section">
            <h4>صفحه مبدأ</h4>
            <p><strong>{{ selectedMissing.title }}</strong> ({{ selectedMissing.keywordCount }} کلمه کلیدی)</p>
            <p class="tcla-modal__muted">کلمه کلیدی: {{ selectedMissing.keyword }}</p>
          </div>
          <div class="tcla-modal__section">
            <h4>صفحه مقصد</h4>
            <p><strong>{{ selectedMissing.targetTitle }}</strong> ({{ selectedMissing.targetKeywordCount }} کلمه کلیدی)</p>
            <p class="tcla-modal__muted">کلمه کلیدی: {{ selectedMissing.targetKeyword }}</p>
          </div>
          <div class="tcla-modal__section">
            <h4>ارتباط موضوعی</h4>
            <p class="tcla-modal__solution">{{ selectedMissing.relationType }}</p>
          </div>
          <div v-if="selectedMissing.commonWords && selectedMissing.commonWords.length > 0" class="tcla-modal__section">
            <h4>کلمات مشترک</h4>
            <div>
              <span v-for="(word, widx) in selectedMissing.commonWords" :key="widx" class="tcla-word-chip">{{ word }}</span>
            </div>
          </div>
          <div class="tcla-modal__section">
            <h4>دلیل نیاز به لینک</h4>
            <p class="tcla-modal__warn">{{ selectedMissing.reason }}</p>
          </div>
          <div class="tcla-modal__section">
            <h4>لنگر پیشنهادی</h4>
            <div class="tcla-modal__code-block">{{ selectedMissing.suggestedAnchor }}</div>
          </div>
          <div class="tcla-modal__section">
            <h4>پیشنهاد لینک‌سازی</h4>
            <div class="tcla-modal__highlight">
              از صفحه <strong>{{ selectedMissing.title }}</strong> با لنگر
              <code>"{{ selectedMissing.suggestedAnchor }}"</code>
              به صفحه <strong>{{ selectedMissing.targetTitle }}</strong> لینک دهید.
            </div>
          </div>
          <div class="tcla-modal__section">
            <h4>کد HTML پیشنهادی</h4>
            <div class="tcla-modal__code-block tcla-modal__code-block--dark">
              &lt;a href="{{ selectedMissing.targetUrl || '#' }}"&gt;{{ selectedMissing.suggestedAnchor }}&lt;/a&gt;
            </div>
          </div>
          <div class="tcla-modal__section">
            <h4>متن پیشنهادی</h4>
            <div class="tcla-modal__highlight tcla-modal__highlight--blue">
              برای اطلاعات بیشتر در مورد {{ selectedMissing.suggestedAnchor }}، مقاله جامع ما را مطالعه کنید.
            </div>
          </div>
        </div>
        <div class="tcla-modal__footer">
          <button class="tcla-btn tcla-btn--outline" @click="showMissingModal = false">بستن</button>
          <button class="tcla-btn tcla-btn--primary" @click="copySuggestion">کپی متن</button>
        </div>
      </div>
    </div>

    <!-- Toast -->
    <transition name="toast">
      <div v-if="toastVisible" class="tcla-toast">
        <span class="tcla-toast__icon">✓</span>
        {{ toastMessage }}
      </div>
    </transition>
  </div>
</template>

<script>
/* ============================================================================
 * SEO INTELLIGENCE ENGINE (v2.0)
 * ----------------------------------------------------------------------------
 * A dependency-free, pure-function analysis engine that replaces the old
 * keywordCount heuristic with graph theory + lexical/structural semantic
 * analysis. It never touches Vue reactivity directly — every function takes
 * plain inputs and returns plain data — which keeps it fast, testable and
 * cache-friendly inside Vue computed properties.
 *
 * Pipeline (see `analyze()` at the bottom):
 *   items -> profiles -> graph -> pageRank -> clusters -> hubs -> spokes
 *         -> orphans/deadEnds -> anchors -> missingLinks -> gaps -> scores
 * ========================================================================== */
const SeoEngine = {

  /* ---------------------------------------------------------------------
   * A. PERSIAN TEXT NORMALIZATION & PREPROCESSING
   * ------------------------------------------------------------------- */
  normalizePersian(text) {
    if (!text) return '';
    let t = String(text);
    t = t.replace(/ي/g, 'ی').replace(/ك/g, 'ک');                 // ی/ي و ک/ك
    t = t.replace(/[\u200c\u200b\u200e\u200f]/g, ' ');             // نیم‌فاصله و کاراکترهای جهت
    t = t.replace(/[أإآ]/g, 'ا').replace(/ة/g, 'ه').replace(/ؤ/g, 'و').replace(/ئ/g, 'ی');
    t = t.replace(/[.,،؛:!؟"'`«»()\[\]{}<>\/\\|+*=_%$#@^~]/g, ' '); // علائم نگارشی
    t = t.replace(/\s+/g, ' ').trim();
    return t;
  },

  tokenize(text, stopWords) {
    const clean = this.normalizePersian(text);
    if (!clean) return [];
    const sw = stopWords || [];
    return clean.split(' ').map(w => w.trim()).filter(w => w.length > 1 && !sw.includes(w));
  },

  parseHtml(htmlContent) {
    const empty = { headings: { h2: [], h3: [], h4: [] }, paragraphs: [], listItems: [], anchors: [], plainText: '' };
    if (!htmlContent || typeof DOMParser === 'undefined') return empty;
    let doc;
    try {
      doc = new DOMParser().parseFromString(htmlContent, 'text/html');
    } catch (e) {
      return empty;
    }
    doc.querySelectorAll('script, style').forEach(n => n.remove());
    const headings = {
      h2: Array.from(doc.querySelectorAll('h2')).map(n => n.textContent.trim()).filter(Boolean),
      h3: Array.from(doc.querySelectorAll('h3')).map(n => n.textContent.trim()).filter(Boolean),
      h4: Array.from(doc.querySelectorAll('h4')).map(n => n.textContent.trim()).filter(Boolean)
    };
    const paragraphs = Array.from(doc.querySelectorAll('p')).map(n => n.textContent.trim()).filter(Boolean);
    const listItems = Array.from(doc.querySelectorAll('li')).map(n => n.textContent.trim()).filter(Boolean);
    const anchors = Array.from(doc.querySelectorAll('a')).map(n => ({
      url: n.getAttribute('href') || '', text: n.textContent.trim()
    })).filter(a => a.url && a.url.includes('/'));
    const plainText = (doc.body ? doc.body.textContent : '').replace(/\s+/g, ' ').trim();
    return { headings, paragraphs, listItems, anchors, plainText };
  },

  /* ---------------------------------------------------------------------
   * B. WEIGHTED TERM VECTORS (TF-weighted, field-boosted)
   * ------------------------------------------------------------------- */
  buildTermVector(weightedTexts, stopWords) {
    const vec = {};
    weightedTexts.forEach(({ text, weight }) => {
      this.tokenize(text, stopWords).forEach(tok => { vec[tok] = (vec[tok] || 0) + weight; });
    });
    return vec;
  },

  vectorTopTerms(vec, n) {
    return Object.entries(vec).sort((a, b) => b[1] - a[1]).slice(0, n || 25)
        .map(([term, weight]) => ({ term, weight }));
  },

  weightedCosine(vecA, vecB) {
    const keys = new Set([...Object.keys(vecA), ...Object.keys(vecB)]);
    let dot = 0, magA = 0, magB = 0;
    keys.forEach(k => {
      const a = vecA[k] || 0, b = vecB[k] || 0;
      dot += a * b; magA += a * a; magB += b * b;
    });
    if (magA === 0 || magB === 0) return 0;
    return dot / (Math.sqrt(magA) * Math.sqrt(magB));
  },

  jaccard(setA, setB) {
    const a = new Set(setA), b = new Set(setB);
    if (a.size === 0 && b.size === 0) return 0;
    let inter = 0;
    a.forEach(v => { if (b.has(v)) inter++; });
    const union = new Set([...a, ...b]).size;
    return union === 0 ? 0 : inter / union;
  },

  /* ---------------------------------------------------------------------
   * C. DEFAULT DICTIONARIES (all overridable via component props)
   * ------------------------------------------------------------------- */
  defaultLocations: [
    'تهران', 'اصفهان', 'شیراز', 'مشهد', 'تبریز', 'کرج', 'اهواز', 'قم', 'کرمانشاه',
    'ارومیه', 'رشت', 'زاهدان', 'کرمان', 'یزد', 'اردبیل', 'همدان', 'قزوین', 'ساری',
    'گرگان', 'بندرعباس', 'خرم‌آباد', 'سنندج', 'بوشهر', 'ایلام', 'شهرکرد', 'زنجان',
    'یاسوج', 'بجنورد', 'سمنان', 'شمال', 'جنوب', 'ایران'
  ],
  defaultIndustries: [
    'پزشکی', 'پزشکان', 'کلینیک', 'دندانپزشکی', 'زیبایی', 'فروشگاهی', 'فروشگاه',
    'شرکتی', 'شرکت', 'وکالت', 'حقوقی', 'آموزشی', 'رستوران', 'هتل', 'گردشگری',
    'املاک', 'خودرو', 'مهندسی', 'صنعتی', 'ورزشی', 'بیمه', 'مالی', 'بانکی',
    'کشاورزی', 'ساختمانی', 'معماری', 'موسیقی', 'هنری', 'خیریه', 'دامپزشکی'
  ],
  defaultServiceSeeds: [
    'طراحی', 'سئو', 'بهینه‌سازی', 'تولید', 'محتوا', 'برنامه‌نویسی', 'توسعه',
    'میزبانی', 'هاست', 'دیجیتال', 'مارکتینگ', 'تبلیغات', 'گرافیک', 'اپلیکیشن'
  ],
  intentSignals: [
    { intent: 'price', words: ['قیمت', 'هزینه', 'تعرفه', 'نرخ'] },
    { intent: 'comparison', words: ['مقایسه', 'بهتر', 'تفاوت'] },
    { intent: 'faq', words: ['سوالات', 'پرسش', 'متداول', 'پاسخ'] },
    { intent: 'case-study', words: ['نمونه', 'کار', 'مطالعه', 'موردی', 'کیس'] },
    { intent: 'guide', words: ['راهنما', 'آموزش', 'نحوه', 'چگونه', 'مراحل'] },
    { intent: 'blog', words: ['وبلاگ', 'مقاله', 'اخبار', 'خبر'] }
  ],
  industryGapDictionary: [
    'پزشکی', 'فروشگاهی', 'شرکتی', 'وکالت', 'کلینیک زیبایی', 'دندانپزشکی',
    'رستوران', 'هتل', 'املاک', 'آموزشی', 'خودرو', 'مهندسی', 'صنعتی',
    'ورزشی', 'بیمه', 'گردشگری',
    'تهران', 'اصفهان', 'شیراز', 'مشهد', 'تبریز', 'کرج', 'اهواز', 'قم', 'کرمانشاه',
    'ارومیه', 'رشت', 'زاهدان', 'کرمان', 'یزد', 'اردبیل', 'همدان', 'قزوین', 'ساری',
    'گرگان', 'بندرعباس', 'خرم‌آباد', 'سنندج', 'بوشهر', 'ایلام', 'شهرکرد', 'زنجان',
    'یاسوج', 'بجنورد', 'سمنان', 'شمال', 'جنوب', 'ایران'
  ],
  clusterKeywordMap: [
    { cluster: 'طراحی سایت', words: ['طراحی', 'سایت', 'وب‌سایت', 'وبسایت'] },
    { cluster: 'سئو', words: ['سئو', 'بهینه‌سازی', 'رتبه', 'گوگل'] },
    { cluster: 'فروشگاهی', words: ['فروشگاه', 'فروشگاهی', 'ووکامرس'] },
    { cluster: 'پزشکی', words: ['پزشکی', 'پزشک', 'کلینیک', 'دندانپزشکی', 'دامپزشکی'] },
    { cluster: 'شرکتی', words: ['شرکت', 'شرکتی', 'سازمانی', 'کسب\u200cوکار'] },
    { cluster: 'محلی', words: [] }
  ],

  /* ---------------------------------------------------------------------
   * D. SEMANTIC PROFILE BUILDER (§ Content Analysis Engine)
   * ------------------------------------------------------------------- */
  classifyIntent(textJoined, locations, industries) {
    const norm = this.normalizePersian(textJoined);
    for (const signal of this.intentSignals) {
      if (signal.words.some(w => norm.includes(w))) return signal.intent;
    }
    if (locations.length > 0) return 'location';
    if (industries.length > 0) return 'service';
    return 'service';
  },

  extractMatches(text, dictionary) {
    const norm = this.normalizePersian(text);
    const found = [];
    dictionary.forEach(word => {
      const w = this.normalizePersian(word);
      if (w && norm.includes(w) && !found.includes(word)) found.push(word);
    });
    return found;
  },

  // Strip location modifiers to reveal the generic "core" topic of a page,
  // e.g. "طراحی سایت پزشکی در اصفهان" -> "طراحی سایت پزشکی"
  extractTopic(title, locations, stopWords) {
    let norm = this.normalizePersian(title);
    locations.forEach(loc => {
      const l = this.normalizePersian(loc);
      if (l) norm = norm.replace(new RegExp('\\b' + l + '\\b', 'g'), '');
    });
    const tokens = norm.split(' ').filter(w => w.length > 1 && !(stopWords || []).includes(w));
    return tokens.join(' ').trim();
  },

  buildProfile(item, stopWords, config) {
    const cfg = config || {};
    const locations = cfg.locations || this.defaultLocations;
    const industries = cfg.industries || this.defaultIndustries;
    const serviceSeeds = cfg.serviceSeeds || this.defaultServiceSeeds;

    const html = this.parseHtml(item.htmlContent);
    const title = item.title || '';
    const meta = item.meta_description || item.metaDescription || '';

    const matchedLocations = this.extractMatches(title + ' ' + meta, locations);
    const matchedIndustries = this.extractMatches(title + ' ' + meta + ' ' + html.headings.h2.join(' '), industries);
    const matchedServices = this.extractMatches(title + ' ' + meta, serviceSeeds);
    const topic = this.extractTopic(title, matchedLocations, stopWords);

    const allHeadings = [...html.headings.h2, ...html.headings.h3, ...html.headings.h4];
    const subTopics = [...new Set(this.tokenize(allHeadings.join(' '), stopWords))].slice(0, 20);
    const entities = [...new Set([...matchedLocations, ...matchedIndustries])];

    const bodyText = [meta, ...html.paragraphs, ...html.listItems].join(' ');
    const wordCount = this.tokenize(bodyText, stopWords).length;
    const headingCount = allHeadings.length;

    let contentDepth = 'thin';
    if (wordCount > 600 || headingCount >= 6) contentDepth = 'deep';
    else if (wordCount > 200 || headingCount >= 3) contentDepth = 'medium';

    const termVector = this.buildTermVector([
      { text: title, weight: 4 },
      { text: html.headings.h2.join(' '), weight: 2.2 },
      { text: html.headings.h3.join(' '), weight: 1.6 },
      { text: html.headings.h4.join(' '), weight: 1.2 },
      { text: meta, weight: 1.6 },
      { text: bodyText, weight: 1 }
    ], stopWords);

    return {
      url: item.url, source: item.source, title, keyword: item.keyword || '', meta,
      topic, subTopics, entities,
      locations: matchedLocations, industries: matchedIndustries, services: matchedServices,
      searchIntent: this.classifyIntent(title + ' ' + meta, matchedLocations, matchedIndustries),
      contentDepth, wordCount, headingCount,
      headings: html.headings, paragraphs: html.paragraphs, anchorsOut: html.anchors,
      termVector, semanticKeywords: this.vectorTopTerms(termVector, 15),
      topicTokenCount: this.tokenize(topic, stopWords).length,
      keywordCount: this.tokenize(item.keyword || '', stopWords).length
    };
  },

  buildAllProfiles(items, stopWords, config) {
    return (items || []).map(item => this.buildProfile(item, stopWords, config));
  },

  /* ---------------------------------------------------------------------
   * E. SEMANTIC SIMILARITY (§ Content Similarity — replaces keywordCount)
   * ------------------------------------------------------------------- */
  semanticSimilarity(profileA, profileB, stopWords) {
    if (!profileA || !profileB) return 0;
    const titleSim = this.weightedCosine(
        this.buildTermVector([{ text: profileA.title, weight: 1 }], stopWords),
        this.buildTermVector([{ text: profileB.title, weight: 1 }], stopWords));

    const headA = [...profileA.headings.h2, ...profileA.headings.h3, ...profileA.headings.h4].join(' ');
    const headB = [...profileB.headings.h2, ...profileB.headings.h3, ...profileB.headings.h4].join(' ');
    const headingSim = this.weightedCosine(
        this.buildTermVector([{ text: headA, weight: 1 }], stopWords),
        this.buildTermVector([{ text: headB, weight: 1 }], stopWords));

    const metaSim = this.weightedCosine(
        this.buildTermVector([{ text: profileA.meta, weight: 1 }], stopWords),
        this.buildTermVector([{ text: profileB.meta, weight: 1 }], stopWords));

    const bodySim = this.weightedCosine(profileA.termVector, profileB.termVector);
    const entitySim = this.jaccard(profileA.entities, profileB.entities);
    const topicSim = (profileA.topic && profileB.topic) ? this.weightedCosine(
        this.buildTermVector([{ text: profileA.topic, weight: 1 }], stopWords),
        this.buildTermVector([{ text: profileB.topic, weight: 1 }], stopWords)) : 0;

    const score = titleSim * 0.30 + headingSim * 0.18 + metaSim * 0.14 + bodySim * 0.13 + entitySim * 0.10 + topicSim * 0.15;
    return Math.round(Math.min(1, Math.max(0, score)) * 100);
  },

  /* ---------------------------------------------------------------------
   * F. GRAPH ENGINE (§ 1 — incoming/outgoing/parent/child/sibling/depth)
   * ------------------------------------------------------------------- */
  resolveUrl(url, knownUrlSet) {
    if (!url) return null;
    if (knownUrlSet.has(url)) return url;
    try { const decoded = decodeURI(url); if (knownUrlSet.has(decoded)) return decoded; } catch (e) { /* ignore */ }
    let found = null;
    knownUrlSet.forEach(u => { if (!found && (url.includes(u) || u.includes(url))) found = u; });
    return found;
  },

  buildGraph(profiles, stopWords, familyThreshold) {
    const threshold = familyThreshold || 55;
    const urlSet = new Set(profiles.map(p => p.url));
    const nodes = {};

    profiles.forEach(p => {
      nodes[p.url] = {
        url: p.url, title: p.title, source: p.source, profile: p,
        incomingLinks: [], outgoingLinks: [], parents: [], children: [], siblings: [],
        depth: null, distanceFromHub: null, clusterId: null,
        isHub: false, isOrphan: false, isDeadEnd: false
      };
    });

    profiles.forEach(p => {
      const node = nodes[p.url];
      p.anchorsOut.forEach(a => {
        const resolved = this.resolveUrl(a.url, urlSet);
        if (resolved && resolved !== p.url) {
          node.outgoingLinks.push({ url: resolved, anchorText: a.text });
          nodes[resolved].incomingLinks.push({ url: p.url, anchorText: a.text });
        }
      });
    });

    const cache = {};
    const simKey = (a, b) => (a < b ? a + '|' + b : b + '|' + a);
    const getSim = (a, b) => {
      const k = simKey(a.url, b.url);
      if (cache[k] === undefined) cache[k] = this.semanticSimilarity(a, b, stopWords);
      return cache[k];
    };

    for (let i = 0; i < profiles.length; i++) {
      for (let j = i + 1; j < profiles.length; j++) {
        const a = profiles[i], b = profiles[j];
        const sim = getSim(a, b);
        if (sim < threshold) continue;
        if (a.topicTokenCount !== b.topicTokenCount) {
          const [parent, child] = a.topicTokenCount < b.topicTokenCount ? [a, b] : [b, a];
          nodes[child.url].parents.push({ url: parent.url, title: parent.title, similarity: sim });
          nodes[parent.url].children.push({ url: child.url, title: child.title, similarity: sim });
        } else {
          nodes[a.url].siblings.push({ url: b.url, title: b.title, similarity: sim });
          nodes[b.url].siblings.push({ url: a.url, title: a.title, similarity: sim });
        }
      }
    }

    Object.values(nodes).forEach(n => {
      ['parents', 'children', 'siblings'].forEach(key => {
        const map = {};
        n[key].forEach(r => { if (!map[r.url] || map[r.url].similarity < r.similarity) map[r.url] = r; });
        n[key] = Object.values(map).sort((x, y) => y.similarity - x.similarity);
      });
      n.isOrphan = n.incomingLinks.length === 0;
      n.isDeadEnd = n.outgoingLinks.length === 0;
    });

    return { nodes, urlSet };
  },

  computeDepths(graph, hubUrls) {
    const { nodes } = graph;
    Object.values(nodes).forEach(n => { n.depth = null; n.distanceFromHub = null; });
    const queue = [];
    hubUrls.forEach(url => { if (nodes[url]) { nodes[url].depth = 0; nodes[url].distanceFromHub = 0; queue.push(url); } });
    let head = 0;
    while (head < queue.length) {
      const current = queue[head++];
      const node = nodes[current];
      const neighbors = [
        ...node.outgoingLinks.map(l => l.url), ...node.incomingLinks.map(l => l.url),
        ...node.children.map(l => l.url), ...node.parents.map(l => l.url)
      ];
      neighbors.forEach(nb => {
        if (nodes[nb] && nodes[nb].depth === null) {
          nodes[nb].depth = node.depth + 1;
          nodes[nb].distanceFromHub = node.distanceFromHub + 1;
          queue.push(nb);
        }
      });
    }
    return graph;
  },

  /* ---------------------------------------------------------------------
   * G. INTERNAL PAGERANK (§ 5 — link equity / authority / importance)
   * ------------------------------------------------------------------- */
  computePageRank(graph, damping, iterations) {
    const d = damping || 0.85, iters = iterations || 30;
    const urls = Object.keys(graph.nodes);
    const N = urls.length;
    if (N === 0) return { raw: {}, normalized: {} };

    let ranks = {};
    urls.forEach(u => { ranks[u] = 1 / N; });

    for (let it = 0; it < iters; it++) {
      let danglingSum = 0;
      urls.forEach(u => { if (graph.nodes[u].outgoingLinks.length === 0) danglingSum += ranks[u]; });
      const newRanks = {};
      urls.forEach(u => {
        let incomingSum = 0;
        graph.nodes[u].incomingLinks.forEach(inLink => {
          const src = graph.nodes[inLink.url];
          if (src && src.outgoingLinks.length > 0) incomingSum += ranks[inLink.url] / src.outgoingLinks.length;
        });
        newRanks[u] = (1 - d) / N + d * (incomingSum + danglingSum / N);
      });
      ranks = newRanks;
    }

    const max = Math.max(...Object.values(ranks), 0.00001);
    const normalized = {};
    urls.forEach(u => { normalized[u] = Math.round((ranks[u] / max) * 100); });
    return { raw: ranks, normalized };
  },

  /* ---------------------------------------------------------------------
   * H. TOPICAL CLUSTERING (§ 6)
   * ------------------------------------------------------------------- */
  assignCluster(profile, clusterMap) {
    const norm = this.normalizePersian(profile.title + ' ' + profile.topic);
    for (const entry of clusterMap) {
      if (entry.words.some(w => w && norm.includes(this.normalizePersian(w)))) return entry.cluster;
    }
    return profile.locations.length > 0 ? 'محلی' : 'سایر';
  },

  buildTopicalClusters(profiles, graph, pageRank, clusterMap) {
    const map = clusterMap || this.clusterKeywordMap;
    const clusters = {};
    profiles.forEach(p => {
      const clusterName = this.assignCluster(p, map);
      if (!clusters[clusterName]) clusters[clusterName] = { name: clusterName, pages: [] };
      clusters[clusterName].pages.push(p.url);
      graph.nodes[p.url].clusterId = clusterName;
    });

    return Object.values(clusters).map(c => {
      const ranks = c.pages.map(u => pageRank.normalized[u] || 0);
      const orphanCount = c.pages.filter(u => graph.nodes[u].isOrphan).length;
      const deadEndCount = c.pages.filter(u => graph.nodes[u].isDeadEnd).length;
      const avgAuthority = ranks.length ? Math.round(ranks.reduce((s, v) => s + v, 0) / ranks.length) : 0;
      return {
        name: c.name, pageCount: c.pages.length, pages: c.pages, avgAuthority, orphanCount, deadEndCount,
        healthScore: Math.max(0, Math.round(avgAuthority - (orphanCount + deadEndCount) * (100 / Math.max(c.pages.length, 1))))
      };
    }).sort((a, b) => b.pageCount - a.pageCount);
  },

  /* ---------------------------------------------------------------------
   * I. HUB & SPOKE DETECTION (§ 3, § 4)
   * ------------------------------------------------------------------- */
  detectHubs(graph, pageRank, topicalClusters) {
    const hubs = [];
    topicalClusters.forEach(cluster => {
      if (cluster.pages.length < 2) return;
      let best = null;
      cluster.pages.forEach(url => {
        const node = graph.nodes[url];
        const tokenCount = node.profile.topicTokenCount;
        const score = node.incomingLinks.length * 2 + node.children.length * 3 +
            (pageRank.normalized[url] || 0) * 0.5 - tokenCount * 4;
        if (!best || score > best.score) best = { url, score, tokenCount };
      });
      if (!best) return;

      const hubNode = graph.nodes[best.url];
      hubNode.isHub = true;
      const expectedChildren = hubNode.children.map(c => c.url);
      const actualOutgoingUrls = hubNode.outgoingLinks.map(l => l.url);
      const missingOutgoing = expectedChildren.filter(u => !actualOutgoingUrls.includes(u));
      const hubScoreRaw = hubNode.incomingLinks.length * 2 + hubNode.outgoingLinks.length * 1.5 +
          hubNode.children.length * 3 + (pageRank.normalized[best.url] || 0) * 0.5;

      hubs.push({
        url: best.url, title: hubNode.title, cluster: cluster.name,
        hubScore: Math.min(100, Math.round(hubScoreRaw)),
        expectedOutgoing: expectedChildren.length, actualOutgoing: hubNode.outgoingLinks.length,
        missingOutgoing: missingOutgoing.map(u => ({ url: u, title: graph.nodes[u] ? graph.nodes[u].title : u })),
        isDeadEndHub: hubNode.outgoingLinks.length === 0 && expectedChildren.length > 0
      });
    });
    return hubs.sort((a, b) => b.hubScore - a.hubScore);
  },

  detectSpokes(graph, hubs) {
    const hubUrlSet = new Set(hubs.map(h => h.url));
    const spokes = [];
    Object.values(graph.nodes).forEach(node => {
      if (hubUrlSet.has(node.url)) return;
      if (node.parents.length === 0 && node.siblings.length === 0) return;
      const parent = node.parents[0] || null;
      const hub = hubs.find(h => h.cluster === node.clusterId) || null;
      const outUrls = node.outgoingLinks.map(l => l.url);
      const missingParentLink = parent ? !outUrls.includes(parent.url) : false;
      const missingHubLink = hub && (!parent || parent.url !== hub.url) ? !outUrls.includes(hub.url) : false;
      const missingSiblingLinks = node.siblings.filter(s => !outUrls.includes(s.url)).slice(0, 2);

      if (missingParentLink || missingHubLink || missingSiblingLinks.length > 0) {
        spokes.push({
          url: node.url, title: node.title, source: node.profile.source, cluster: node.clusterId,
          parent, hub, missingParentLink, missingHubLink, missingSiblingLinks
        });
      }
    });
    return spokes;
  },

  /* ---------------------------------------------------------------------
   * J. ORPHAN / DEAD-END PAGES (§ 8, § 9)
   * ------------------------------------------------------------------- */
  detectOrphans(graph, pageRank, weakThreshold) {
    const wt = weakThreshold || 15;
    return Object.values(graph.nodes)
        .filter(n => n.incomingLinks.length === 0 || (pageRank.normalized[n.url] || 0) < wt)
        .map(n => ({
          url: n.url, title: n.title, source: n.profile.source,
          incomingCount: n.incomingLinks.length, authority: pageRank.normalized[n.url] || 0,
          severity: n.incomingLinks.length === 0 ? 'کاملاً یتیم' : 'لینک ورودی ضعیف'
        }));
  },

  detectDeadEnds(graph) {
    return Object.values(graph.nodes).filter(n => n.outgoingLinks.length === 0)
        .map(n => ({ url: n.url, title: n.title, source: n.profile.source, incomingCount: n.incomingLinks.length }));
  },

  /* ---------------------------------------------------------------------
   * K. ANCHOR TEXT DIVERSITY (§ 7)
   * ------------------------------------------------------------------- */
  analyzeAnchors(graph) {
    const results = [];
    Object.values(graph.nodes).forEach(node => {
      const anchors = node.incomingLinks.map(l => this.normalizePersian(l.anchorText || 'نامشخص'));
      if (anchors.length === 0) return;
      const freq = {};
      anchors.forEach(a => { freq[a] = (freq[a] || 0) + 1; });
      const total = anchors.length;
      const [topAnchor, topCount] = Object.entries(freq).sort((a, b) => b[1] - a[1])[0];
      const exactMatchRatio = topCount / total;
      const uniqueRatio = Object.keys(freq).length / total;
      const overOptimized = exactMatchRatio > 0.6 && total >= 3;
      const duplicates = Object.entries(freq).filter(([, c]) => c > 1).map(([text, c]) => ({ text, count: c }));
      const diversityScore = Math.round(uniqueRatio * 100);
      const lowDiversity = diversityScore < 40 && total >= 3;

      const suggestions = [];
      if (overOptimized || lowDiversity) {
        node.profile.subTopics.slice(0, 3).forEach(st => {
          const alt = (node.profile.topic + ' ' + st).trim();
          if (alt && this.normalizePersian(alt) !== topAnchor) suggestions.push(alt);
        });
        if (node.profile.title && this.normalizePersian(node.profile.title) !== topAnchor) suggestions.push(node.profile.title);
      }

      results.push({
        url: node.url, title: node.title, totalAnchors: total, topAnchor,
        topAnchorRatio: Math.round(exactMatchRatio * 100), diversityScore, overOptimized, lowDiversity,
        duplicates, suggestions: [...new Set(suggestions)].slice(0, 3)
      });
    });
    return results.sort((a, b) => a.diversityScore - b.diversityScore);
  },

  /* ---------------------------------------------------------------------
   * L. MISSING LINKS (expanded) & LINK OPPORTUNITIES (§ 10, § 11, § 16)
   * ------------------------------------------------------------------- */
  pickInsertionHeading(sourceProfile, targetProfile) {
    const targetTerms = new Set(Object.keys(targetProfile.termVector));
    const allHeadings = [
      ...sourceProfile.headings.h2.map(h => ({ text: h, level: 'H2' })),
      ...sourceProfile.headings.h3.map(h => ({ text: h, level: 'H3' }))
    ];
    let best = null, bestScore = 0;
    allHeadings.forEach(h => {
      const overlap = this.tokenize(h.text, []).filter(t => targetTerms.has(t)).length;
      if (overlap > bestScore) { bestScore = overlap; best = h; }
    });
    return best ? `بعد از تیتر «${best.text}» (${best.level})` : 'انتهای مقاله';
  },

  buildSuggestionSentence(targetTitle, anchor) {
    return `برای آشنایی بیشتر با ${targetTitle} می‌توانید مقاله «${anchor}» را مطالعه کنید.`;
  },

  buildMissingLinkSuggestions(graph, hubs, spokes, stopWords, contextualThreshold) {
    const threshold = contextualThreshold || 70;
    const suggestions = [];

    spokes.forEach(spoke => {
      const sourceNode = graph.nodes[spoke.url];
      if (spoke.missingParentLink && spoke.parent) {
        const targetNode = graph.nodes[spoke.parent.url];
        suggestions.push({
          type: 'missingParent', typeLabel: 'لینک به صفحه والد',
          source: spoke.source, sourceUrl: spoke.url, sourceTitle: spoke.title,
          targetUrl: spoke.parent.url, targetTitle: spoke.parent.title, similarity: spoke.parent.similarity,
          suggestedAnchor: targetNode.title, insertionPoint: this.pickInsertionHeading(sourceNode.profile, targetNode.profile),
          suggestedSentence: this.buildSuggestionSentence(targetNode.title, targetNode.title),
          reason: `چون شباهت معنایی ${spoke.parent.similarity}٪ است و «${spoke.parent.title}» صفحه والد موضوعی این مقاله محسوب می‌شود`
        });
      }
      if (spoke.missingHubLink && spoke.hub) {
        const targetNode = graph.nodes[spoke.hub.url];
        suggestions.push({
          type: 'missingHub', typeLabel: 'لینک به صفحه هاب',
          source: spoke.source, sourceUrl: spoke.url, sourceTitle: spoke.title,
          targetUrl: spoke.hub.url, targetTitle: spoke.hub.title, similarity: spoke.hub.hubScore,
          suggestedAnchor: targetNode.title, insertionPoint: this.pickInsertionHeading(sourceNode.profile, targetNode.profile),
          suggestedSentence: this.buildSuggestionSentence(targetNode.title, targetNode.title),
          reason: `چون این صفحه یک Spoke است و باید به صفحه هاب «${spoke.hub.title}» لینک دهد`
        });
      }
      spoke.missingSiblingLinks.forEach(sib => {
        const targetNode = graph.nodes[sib.url];
        suggestions.push({
          type: 'missingSibling', typeLabel: 'لینک به صفحه خواهر/برادر',
          source: spoke.source, sourceUrl: spoke.url, sourceTitle: spoke.title,
          targetUrl: sib.url, targetTitle: sib.title, similarity: sib.similarity,
          suggestedAnchor: targetNode.title, insertionPoint: this.pickInsertionHeading(sourceNode.profile, targetNode.profile),
          suggestedSentence: this.buildSuggestionSentence(targetNode.title, targetNode.title),
          reason: `چون شباهت معنایی با «${sib.title}» برابر ${sib.similarity}٪ است و هر دو در یک سطح موضوعی هستند`
        });
      });
    });

    hubs.forEach(hub => {
      const hubNode = graph.nodes[hub.url];
      hub.missingOutgoing.forEach(child => {
        const childNode = graph.nodes[child.url];
        if (!childNode) return;
        suggestions.push({
          type: 'missingChild', typeLabel: 'لینک هاب به زیرصفحه',
          source: hubNode.profile.source, sourceUrl: hub.url, sourceTitle: hub.title,
          targetUrl: child.url, targetTitle: child.title, similarity: null,
          suggestedAnchor: child.title, insertionPoint: this.pickInsertionHeading(hubNode.profile, childNode.profile),
          suggestedSentence: this.buildSuggestionSentence(child.title, child.title),
          reason: `چون این صفحه، هاب خوشه‌ی «${hub.cluster}» است و باید به همه زیرصفحه‌ها از جمله «${child.title}» لینک دهد`
        });
      });
    });

    const byCluster = {};
    Object.values(graph.nodes).forEach(n => { (byCluster[n.clusterId] = byCluster[n.clusterId] || []).push(n); });
    Object.values(byCluster).forEach(nodesInCluster => {
      for (let i = 0; i < nodesInCluster.length; i++) {
        for (let j = i + 1; j < nodesInCluster.length; j++) {
          const a = nodesInCluster[i], b = nodesInCluster[j];
          const linked = a.outgoingLinks.some(l => l.url === b.url) || b.outgoingLinks.some(l => l.url === a.url);
          if (linked) continue;
          const sim = this.semanticSimilarity(a.profile, b.profile, stopWords);
          if (sim >= threshold) {
            suggestions.push({
              type: 'missingContextual', typeLabel: 'لینک محتوایی مرتبط',
              source: a.profile.source, sourceUrl: a.url, sourceTitle: a.title,
              targetUrl: b.url, targetTitle: b.title, similarity: sim,
              suggestedAnchor: b.title, insertionPoint: this.pickInsertionHeading(a.profile, b.profile),
              suggestedSentence: this.buildSuggestionSentence(b.title, b.title),
              reason: `چون شباهت معنایی ${sim}٪ است اما هیچ لینک داخلی بین این دو صفحه وجود ندارد`
            });
          }
        }
      }
    });

    return suggestions;
  },

  buildLinkOpportunities(missingLinkSuggestions, limitPerSource) {
    const limit = limitPerSource || 5;
    const grouped = {};
    missingLinkSuggestions.forEach(s => { (grouped[s.sourceUrl] = grouped[s.sourceUrl] || []).push(s); });
    const result = [];
    Object.values(grouped).forEach(list => {
      list.sort((a, b) => (b.similarity || 50) - (a.similarity || 50));
      result.push(...list.slice(0, limit));
    });
    return result.sort((a, b) => (b.similarity || 50) - (a.similarity || 50));
  },

  /* ---------------------------------------------------------------------
   * M. KEYWORD GAP ANALYSIS (§ 13, § Content Gap Analysis)
   * ------------------------------------------------------------------- */
  buildKeywordGaps(profiles, hubs, gapDictionary) {
    const dict = gapDictionary || this.industryGapDictionary;
    const byTopic = {};
    profiles.forEach(p => {
      if (!byTopic[p.topic]) byTopic[p.topic] = { topic: p.topic, covered: new Set(), pages: [] };
      p.industries.forEach(ind => byTopic[p.topic].covered.add(ind));
      byTopic[p.topic].pages.push(p.url);
    });

    const gaps = [];
    Object.values(byTopic).forEach(group => {
      if (group.pages.length < 2 || !group.topic) return; // only for established topic groups
      const missing = dict.filter(item => ![...group.covered].some(c => c.includes(item) || item.includes(c)));
      const hub = hubs.find(h => group.pages.includes(h.url));
      missing.forEach(modifier => {
        gaps.push({
          topic: group.topic, suggestedTitle: `${group.topic} ${modifier}`.trim(),
          targetKeyword: `${group.topic} ${modifier}`.trim(),
          relatedHub: hub ? hub.title : (group.topic || 'نامشخص'), relatedHubUrl: hub ? hub.url : null,
          internalLinksNeeded: group.pages.slice(0, 3)
        });
      });
    });
    return gaps;
  },

  /* ---------------------------------------------------------------------
   * N. CLUSTER HEALTH (§ 14)
   * ------------------------------------------------------------------- */
  buildClusterHealth(topicalClusters, keywordGaps, missingLinkSuggestions, pageScores) {
    return topicalClusters.map(cluster => {
      const gapsForCluster = keywordGaps.filter(g => cluster.pages.includes(g.relatedHubUrl) || g.topic === cluster.name);
      const missingForCluster = missingLinkSuggestions.filter(s =>
          cluster.pages.includes(s.sourceUrl) || cluster.pages.includes(s.targetUrl));
      const weakPages = cluster.pages.filter(u => (pageScores[u] ? pageScores[u].seoScore : 0) < 40);
      const dictSize = this.industryGapDictionary.length;
      const coveredCount = Math.max(0, dictSize - gapsForCluster.length);
      const coverage = Math.min(100, Math.round((coveredCount / dictSize) * 100));

      return {
        name: cluster.name, coverage, authority: cluster.avgAuthority, pageCount: cluster.pageCount,
        missingPagesCount: gapsForCluster.length, missingLinksCount: missingForCluster.length,
        weakPagesCount: weakPages.length, weakPages
      };
    });
  },

  /* ---------------------------------------------------------------------
   * O. SCORING (§ 18)
   * ------------------------------------------------------------------- */
  contentDepthScore(depth) { return { thin: 30, medium: 65, deep: 95 }[depth] || 30; },

  buildPageScores(graph, pageRank, hubs, spokes, anchorAnalysis, missingLinkSuggestions) {
    const hubUrlSet = new Set(hubs.map(h => h.url));
    const hubByUrl = {}; hubs.forEach(h => { hubByUrl[h.url] = h; });
    const anchorByUrl = {}; anchorAnalysis.forEach(a => { anchorByUrl[a.url] = a; });
    const missingCountByUrl = {};
    missingLinkSuggestions.forEach(s => { missingCountByUrl[s.sourceUrl] = (missingCountByUrl[s.sourceUrl] || 0) + 1; });

    const scores = {};
    Object.values(graph.nodes).forEach(node => {
      const authorityScore = pageRank.normalized[node.url] || 0;
      const depthScore = this.contentDepthScore(node.profile.contentDepth);
      const hubScore = hubUrlSet.has(node.url) ? hubByUrl[node.url].hubScore : Math.max(0, 40 - node.profile.topicTokenCount * 5);

      const anchorInfo = anchorByUrl[node.url];
      let anchorScore = 70;
      if (anchorInfo) {
        anchorScore = anchorInfo.diversityScore - (anchorInfo.overOptimized ? 20 : 0);
        anchorScore = Math.max(0, Math.min(100, anchorScore));
      } else if (node.incomingLinks.length === 0) {
        anchorScore = 0;
      }

      const missingPenalty = Math.min(40, (missingCountByUrl[node.url] || 0) * 8);
      const linkingBase = Math.min(100, node.incomingLinks.length * 10 + node.outgoingLinks.length * 8);
      const internalLinkingScore = Math.max(0, Math.min(100, linkingBase - missingPenalty));

      const relations = node.parents.concat(node.siblings, node.children);
      const topicalScore = relations.length ? Math.round(relations.reduce((s, r) => s + r.similarity, 0) / relations.length) : 0;

      const seoScore = Math.round(
          depthScore * 0.20 + internalLinkingScore * 0.20 + authorityScore * 0.20 +
          anchorScore * 0.15 + topicalScore * 0.15 + hubScore * 0.10
      );

      scores[node.url] = {
        seoScore, internalLinkingScore, authorityScore, topicalScore,
        hubScore: Math.round(hubScore), anchorScore: Math.round(anchorScore)
      };
    });
    return scores;
  },

  /* ---------------------------------------------------------------------
   * P. ORCHESTRATOR — runs the full pipeline once, returns everything
   * ------------------------------------------------------------------- */
  analyze(items, stopWords, config) {
    const cfg = config || {};
    const profiles = this.buildAllProfiles(items, stopWords, cfg);
    const graph = this.buildGraph(profiles, stopWords, cfg.familyThreshold);
    const pageRank = this.computePageRank(graph, 0.85, 30);
    const topicalClusters = this.buildTopicalClusters(profiles, graph, pageRank, cfg.clusterMap);
    const hubs = this.detectHubs(graph, pageRank, topicalClusters);
    this.computeDepths(graph, hubs.map(h => h.url));
    const spokes = this.detectSpokes(graph, hubs);
    const orphans = this.detectOrphans(graph, pageRank, cfg.weakThreshold);
    const deadEnds = this.detectDeadEnds(graph);
    const anchorAnalysis = this.analyzeAnchors(graph);
    const missingLinkSuggestions = this.buildMissingLinkSuggestions(graph, hubs, spokes, stopWords, cfg.contextualThreshold);
    const linkOpportunities = this.buildLinkOpportunities(missingLinkSuggestions, cfg.limitPerSource);
    const keywordGaps = this.buildKeywordGaps(profiles, hubs, cfg.gapDictionary);
    const pageScores = this.buildPageScores(graph, pageRank, hubs, spokes, anchorAnalysis, missingLinkSuggestions);
    const clusterHealth = this.buildClusterHealth(topicalClusters, keywordGaps, missingLinkSuggestions, pageScores);

    return {
      profiles, graph, pageRank, topicalClusters, hubs, spokes, orphans, deadEnds,
      anchorAnalysis, missingLinkSuggestions, linkOpportunities, keywordGaps, pageScores, clusterHealth
    };
  }
};

export default {
  name: 'TopicClusterLinkAnalysis',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    stopWords: {
      type: Array,
      default: () => [
        'از', 'با', 'برای', 'در', 'به', 'بر', 'روی', 'زیر', 'کنار',
        'جلوی', 'پشت', 'داخل', 'خارج', 'بالای', 'پایین', 'نزدیک',
        'دور', 'بین', 'میان', 'طریق', 'وسیلۀ', 'توسط', 'بجز', 'غیر',
        'مثل', 'مانند', 'همانند', 'چون', 'چرا', 'زیرا', 'چراکه',
        'که', 'تا', 'مگر', 'آیا', 'چه', 'چگونه', 'چطور', 'کجا',
        'کی', 'چند', 'چقدر', 'کدام', 'کدامین', 'این', 'آن', 'اینها',
        'آنها', 'ما', 'شما', 'او', 'ایشان', 'خود', 'خودی', 'یک', 'دو',
        'سه', 'چهار', 'پنج', 'شش', 'هفت', 'هشت', 'نه', 'ده', 'صد', 'هزار',
        'و', 'یا', 'اما', 'پس', 'پس‌از', 'پیش', 'پیش‌از', 'بعد', 'بعداز'
      ]
    },
    // ---- v2.0 SEO Intelligence Engine configuration (all optional) ----
    locations: { type: Array, default: null },       // fallback: SeoEngine.defaultLocations
    industries: { type: Array, default: null },       // fallback: SeoEngine.defaultIndustries
    serviceSeeds: { type: Array, default: null },     // fallback: SeoEngine.defaultServiceSeeds
    clusterMap: { type: Array, default: null },       // fallback: SeoEngine.clusterKeywordMap
    gapDictionary: { type: Array, default: null },    // fallback: SeoEngine.industryGapDictionary
    familyThreshold: { type: Number, default: 55 },   // min similarity % to infer parent/child/sibling
    contextualThreshold: { type: Number, default: 70 },// min similarity % to suggest a contextual link
    weakThreshold: { type: Number, default: 15 },     // authority % below which a page is "weak incoming"
    limitPerSource: { type: Number, default: 5 }      // max link opportunities suggested per source page
  },
  data() {
    return {
      sortBy: 'keywordCount',
      filterStatus: 'all',
      searchQuery: '',
      showModal: false,
      showMissingModal: false,
      showOpportunityModal: false,
      selectedSuggestion: null,
      selectedMissing: null,
      selectedOpportunity: null,
      openClusters: {},
      toastVisible: false,
      toastMessage: '',
      activeTab: 'dashboard',
      sortOptions: [
        { value: 'keywordCount', label: 'تعداد کلمات کلیدی (صعودی)' },
        { value: 'keywordCountDesc', label: 'تعداد کلمات کلیدی (نزولی)' },
        { value: 'health', label: 'وضعیت سلامت' },
        { value: 'links', label: 'تعداد لینک‌ها' }
      ],
      filterOptions: [
        { value: 'all', label: 'همه خوشه‌ها' },
        { value: 'healthy', label: 'سالم' },
        { value: 'warning', label: 'هشدار' },
        { value: 'unhealthy', label: 'مشکل‌دار' }
      ]
    };
  },
  computed: {
    clusters() {
      if (!this.items || this.items.length === 0) return [];

      const clusters = [];
      const pageMap = this.buildPageMap();
      const groupedPages = this.groupPagesByKeywordCount(pageMap);

      Object.keys(groupedPages).forEach(keywordCount => {
        const pages = groupedPages[keywordCount];
        console.log("pages is",pages)
        pages.forEach(page => {
          const cluster = {
            title: page.title,
            keyword: page.keyword,
            source: page.source,
            keywordCount: page.keywordCount,
            health: 'healthy',
            linkedPages: [],
            errors: [],
            missingLinks: [],
            incomingLinks: 0,
            outgoingLinks: page.outgoingLinks.length,
            url: page.url
          };

          const incomingPages = this.getIncomingPages(page, pageMap);

          incomingPages.forEach(incoming => {
            const isCorrect = incoming.keywordCount > page.keywordCount;
            const linkInfo = this.findLinkInfo(incoming, page);
            const levelDiff = incoming.keywordCount - page.keywordCount;

            cluster.linkedPages.push({
              title: incoming.title,
              keyword: incoming.keyword,
              source: incoming.source,
              keywordCount: incoming.keywordCount,
              anchorText: linkInfo ? linkInfo.anchorText : 'نامشخص',
              isCorrect: isCorrect,
              url: incoming.url,
              levelDifference: levelDiff
            });

            if (isCorrect) {
              cluster.incomingLinks++;
              if (levelDiff > 1) {
                cluster.errors.push(
                    `صفه "${incoming.title}" با ${incoming.keywordCount} کلمه کلیدی به "${page.title}" با ${page.keywordCount} کلمه کلیدی لینک داده (پرش ${levelDiff} سطحی)`
                );
                if (cluster.health !== 'unhealthy') cluster.health = 'warning';
              }
            } else {
              cluster.errors.push(
                  `صفحه "${incoming.title}" با ${incoming.keywordCount} کلمه کلیدی به "${page.title}" با ${page.keywordCount} کلمه کلیدی لینک داده (اشتباه)`
              );
              cluster.health = 'unhealthy';
            }
          });

          const missingLinks = this.findMissingLinks(page, pageMap);
          missingLinks.forEach(missing => {
            cluster.missingLinks.push(missing);
            if (cluster.health !== 'unhealthy') cluster.health = 'warning';
          });

          if (cluster.incomingLinks === 0 && cluster.outgoingLinks === 0) {
            cluster.health = 'unhealthy';
            cluster.errors.push(
                `صفحه "${cluster.title}" کاملاً یتیم است! هیچ لینک ورودی یا خروجی ندارد.`,
                `پیشنهاد: حداقل یک لینک از صفحه اصلی یا مقالات دیگر به این صفحه اضافه کنید.`
            );
          } else if (cluster.incomingLinks === 0 && cluster.outgoingLinks > 0) {
            cluster.health = 'unhealthy';
            cluster.errors.push(
                `صفحه "${cluster.title}" یتیم است! (${cluster.outgoingLinks} لینک خروجی، ۰ ورودی).`,
                `پیشنهاد: از صفحات دیگر به این صفحه لینک دهید.`
            );
          } else if (cluster.incomingLinks > 0 && cluster.outgoingLinks === 0) {
            if (cluster.health !== 'unhealthy') cluster.health = 'warning';
            cluster.errors.push(
                `صفحه "${cluster.title}" فقط لینک ورودی دارد (${cluster.incomingLinks}) و هیچ لینک خروجی ندارد.`,
                `پیشنهاد: از این صفحه به صفحات مرتبط لینک دهید.`
            );
          } else if (cluster.incomingLinks > 0 && cluster.outgoingLinks > 0 && cluster.errors.length === 0) {
            cluster.health = 'healthy';
          }

          clusters.push(cluster);
        });
      });

      return clusters;
    },
    filteredClusters() {
      let filtered = this.clusters;

      if (this.filterStatus !== 'all') {
        filtered = filtered.filter(c => c.health === this.filterStatus);
      }
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        filtered = filtered.filter(c =>
            c.title.toLowerCase().includes(query) ||
            c.linkedPages.some(p => p.title.toLowerCase().includes(query))
        );
      }

      switch (this.sortBy) {
        case 'keywordCount':
          filtered.sort((a, b) => a.keywordCount - b.keywordCount);
          break;
        case 'keywordCountDesc':
          filtered.sort((a, b) => b.keywordCount - a.keywordCount);
          break;
        case 'health': {
          const order = { unhealthy: 1, warning: 2, healthy: 3 };
          filtered.sort((a, b) => order[a.health] - order[b.health]);
          break;
        }
        case 'links':
          filtered.sort((a, b) => (b.incomingLinks + b.outgoingLinks) - (a.incomingLinks + a.outgoingLinks));
          break;
      }

      return filtered;
    },
    correctLinks() {
      return this.clusters.reduce((sum, c) => sum + c.linkedPages.filter(p => p.isCorrect).length, 0);
    },
    incorrectLinks() {
      return this.clusters.reduce((sum, c) => sum + c.linkedPages.filter(p => !p.isCorrect).length, 0);
    },
    missingLinks() {
      return this.clusters.reduce((sum, c) => sum + c.missingLinks.length, 0);
    },
    totalInternalLinks() {
      return this.clusters.reduce((sum, c) => sum + c.incomingLinks + c.outgoingLinks, 0);
    },
    totalClusters() {
      return this.clusters.length;
    },
    totalLinkedPages() {
      return this.clusters.reduce((sum, c) => sum + c.linkedPages.length, 0);
    },
    totalAll() {
      return this.correctLinks + this.incorrectLinks + this.missingLinks || 1;
    },
    correctPercent() {
      return Math.round((this.correctLinks / this.totalAll) * 100);
    },
    incorrectPercent() {
      return Math.round((this.incorrectLinks / this.totalAll) * 100);
    },
    missingPercent() {
      return Math.round((this.missingLinks / this.totalAll) * 100);
    },
    overallBadgeClass() {
      const u = this.clusters.filter(c => c.health === 'unhealthy').length;
      const w = this.clusters.filter(c => c.health === 'warning').length;
      if (u > 0) return 'tcla-badge--red';
      if (w > 0) return 'tcla-badge--amber';
      return 'tcla-badge--green';
    },
    overallStatusText() {
      const u = this.clusters.filter(c => c.health === 'unhealthy').length;
      const w = this.clusters.filter(c => c.health === 'warning').length;
      const h = this.clusters.filter(c => c.health === 'healthy').length;
      if (u > 0) return `${u} مشکل`;
      if (w > 0) return `${w} هشدار`;
      return `${h} سالم`;
    },

    /* =====================================================================
     * v2.0 — SEO INTELLIGENCE ENGINE WIRING
     * The whole pipeline runs once per `items` change (Vue caches computed
     * properties), and every dashboard piece below just reads a slice of
     * this single result — no duplicate loops, no recomputation.
     * =================================================================== */
    seoEngineConfig() {
      return {
        locations: this.locations || undefined,
        industries: this.industries || undefined,
        serviceSeeds: this.serviceSeeds || undefined,
        clusterMap: this.clusterMap || undefined,
        gapDictionary: this.gapDictionary || undefined,
        familyThreshold: this.familyThreshold,
        contextualThreshold: this.contextualThreshold,
        weakThreshold: this.weakThreshold,
        limitPerSource: this.limitPerSource
      };
    },
    seoAnalysis() {
      if (!this.items || this.items.length === 0) {
        return {
          profiles: [], graph: { nodes: {}, urlSet: new Set() }, pageRank: { raw: {}, normalized: {} },
          topicalClusters: [], hubs: [], spokes: [], orphans: [], deadEnds: [],
          anchorAnalysis: [], missingLinkSuggestions: [], linkOpportunities: [], keywordGaps: [],
          pageScores: {}, clusterHealth: []
        };
      }
      return SeoEngine.analyze(this.items, this.stopWords, this.seoEngineConfig);
    },
    graph() { return this.seoAnalysis.graph; },
    pageRank() { return this.seoAnalysis.pageRank; },
    topicalClusters() { return this.seoAnalysis.topicalClusters; },
    hubs() { return this.seoAnalysis.hubs; },
    spokes() { return this.seoAnalysis.spokes; },
    orphans() { return this.seoAnalysis.orphans; },
    deadEnds() { return this.seoAnalysis.deadEnds; },
    anchorAnalysis() { return this.seoAnalysis.anchorAnalysis; },
    missingLinkSuggestions() { return this.seoAnalysis.missingLinkSuggestions; },
    linkOpportunities() { return this.seoAnalysis.linkOpportunities; },
    keywordGaps() { return this.seoAnalysis.keywordGaps; },
    pageScores() { return this.seoAnalysis.pageScores; },
    clusterHealth() { return this.seoAnalysis.clusterHealth; },

    dashboardStats() {
      const scores = Object.values(this.pageScores);
      const avg = (arr) => arr.length ? Math.round(arr.reduce((s, v) => s + v, 0) / arr.length) : 0;
      const avgTopicalAuthority = avg(this.topicalClusters.map(c => c.avgAuthority));
      const avgPageRank = avg(Object.values(this.pageRank.normalized || {}));
      const avgAnchorDiversity = avg(this.anchorAnalysis.map(a => a.diversityScore));
      const avgClusterCoverage = avg(this.clusterHealth.map(c => c.coverage));
      const avgLinkEquity = avgPageRank;
      const weakPagesCount = scores.filter(s => s.seoScore < 40).length;
      return { avgTopicalAuthority, avgPageRank, avgAnchorDiversity, avgClusterCoverage, avgLinkEquity, weakPagesCount };
    },

    topScoredPages() {
      return Object.entries(this.pageScores)
          .map(([url, scores]) => ({ url, title: this.graph.nodes[url] ? this.graph.nodes[url].title : url, scores }))
          .sort((a, b) => b.scores.seoScore - a.scores.seoScore)
          .slice(0, 10);
    },

    tabList() {
      return [
        { key: 'dashboard', icon: '📊', label: 'داشبورد هوشمند' },
        { key: 'hubspoke', icon: '🧭', label: 'Hub & Spoke', badge: this.hubs.length + this.spokes.length },
        { key: 'topical', icon: '📁', label: 'اقتدار موضوعی' },
        { key: 'orphans', icon: '🏝️', label: 'یتیم / بن‌بست', badge: this.orphans.length + this.deadEnds.length },
        { key: 'anchors', icon: '⚓', label: 'تنوع انکر' },
        { key: 'opportunities', icon: '💡', label: 'فرصت لینک‌سازی', badge: this.linkOpportunities.length },
        { key: 'gaps', icon: '🔍', label: 'شکاف محتوایی', badge: this.keywordGaps.length },
        { key: 'health', icon: '🩺', label: 'سلامت خوشه‌ها' },
        { key: 'graph', icon: '🕸️', label: 'گراف بصری' },
        { key: 'legacy', icon: '🗂️', label: 'خوشه‌های کلمه کلیدی (v1)' }
      ];
    },

    /* Simple radial hub-spoke layout per cluster for the SVG visual graph. */
    graphLayouts() {
      const layouts = [];
      this.topicalClusters.forEach(cluster => {
        if (cluster.pageCount < 2) return;
        const hub = this.hubs.find(h => h.cluster === cluster.name);
        const others = cluster.pages.filter(u => !hub || u !== hub.url);
        const width = 640, height = Math.max(260, 100 + others.length * 6);
        const cx = width / 2, cy = height / 2, radius = Math.min(width, height) / 2 - 60;
        const nodes = [];
        const edges = [];

        const shortTitle = (t) => (t && t.length > 16 ? t.slice(0, 16) + '…' : (t || ''));

        if (hub) {
          nodes.push({ url: hub.url, x: cx, y: cy, r: 22, type: 'hub', shortTitle: shortTitle(hub.title) });
        }
        others.forEach((url, i) => {
          const node = this.graph.nodes[url];
          if (!node) return;
          const angle = (2 * Math.PI * i) / Math.max(1, others.length);
          const x = cx + radius * Math.cos(angle);
          const y = cy + radius * Math.sin(angle);
          let type = 'sibling';
          if (node.isOrphan) type = 'orphan';
          else if (node.isDeadEnd) type = 'deadend';
          else if (hub && node.parents.some(p => p.url === hub.url)) type = 'spoke';
          nodes.push({ url, x, y, r: 14, type, shortTitle: shortTitle(node.title) });

          if (hub) {
            const linked = node.outgoingLinks.some(l => l.url === hub.url) || hub.actualOutgoing > 0 &&
                this.graph.nodes[hub.url].outgoingLinks.some(l => l.url === url);
            edges.push({ x1: cx, y1: cy, x2: x, y2: y, missing: !linked });
          }
        });

        layouts.push({ clusterName: cluster.name, width, height, nodes, edges });
      });
      return layouts;
    }
  },
  watch: {
    filteredClusters(val) {
      val.forEach((_, i) => {
        if (this.openClusters[i] === undefined) {
          this.$set(this.openClusters, i, i < 3);
        }
      });
    }
  },
  created() {
    this.filteredClusters.forEach((_, i) => {
      this.$set(this.openClusters, i, i < 3);
    });
  },
  methods: {
    copy_data(){
      this.copyText(JSON.stringify(this.filteredClusters), 'متن کپی شد');

    },
    open_edit_blog(source){
      window.open("/dashboard/news/edit-news/"+source)
    },
    toggleCluster(index) {
      this.$set(this.openClusters, index, !this.openClusters[index]);
    },
    showToast(msg) {
      this.toastMessage = msg;
      this.toastVisible = true;
      setTimeout(() => { this.toastVisible = false; }, 2500);
    },
    buildPageMap() {
      const map = {};
      this.items.forEach(item => {
        const keywordCount = this.countKeywords(item.keyword || '');
        map[item.url] = {
          title: item.title,
          url: item.url,
          source: item.source,
          keyword: item.keyword,
          keywordCount: keywordCount,
          htmlContent: item.htmlContent,
          outgoingLinks: this.extractOutgoingLinks(item.htmlContent)
        };
      });
      return map;
    },
    extractOutgoingLinks(htmlContent) {
      if (!htmlContent) return [];
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlContent, 'text/html');
      const links = [];
      doc.querySelectorAll('a').forEach(link => {
        const href = link.getAttribute('href');
        const anchorText = link.textContent.trim();
        if (href && href.includes('/')) links.push({ url: href, anchorText });
      });
      return links;
    },
    groupPagesByKeywordCount(pageMap) {
      const grouped = {};
      Object.values(pageMap).forEach(page => {
        const count = page.keywordCount;
        if (!grouped[count]) grouped[count] = [];
        grouped[count].push(page);
      });
      return grouped;
    },
    getIncomingPages(page, pageMap) {
      const incoming = [];
      Object.values(pageMap).forEach(p => {
        if (p.url === page.url) return;
        if (p.outgoingLinks.some(link => link.url === page.url || decodeURI(link.url) ===  page.url)) {
          incoming.push(p);
        }
      });
      return incoming;
    },
    findLinkInfo(fromPage, toPage) {
      return fromPage.outgoingLinks.find(l => l.url === toPage.url || l.url.includes(toPage.url)) || null;
    },
    findMissingLinks(page, pageMap) {
      const missing = [];
      const targetKeywordCount = page.keywordCount + 1;
      Object.values(pageMap).forEach(p => {
        if (p.url === page.url) return;
        if (p.keywordCount === targetKeywordCount) {
          const hasLink = p.outgoingLinks.some(link => link.url === page.url || link.url.includes(page.url));
          if (!hasLink) {
            const relationResult = this.checkThematicRelation(p.keyword, page.keyword);
            if (relationResult.isRelated) {
              missing.push({
                title: p.title, keyword: p.keyword, keywordCount: p.keywordCount,
                source:p.source,
                suggestedAnchor: page.title, targetTitle: page.title,
                targetKeyword: page.keyword, targetKeywordCount: page.keywordCount,
                targetUrl: page.url, commonWords: relationResult.commonWords,
                relationType: relationResult.type,
                reason: `صفحه "${p.title}" (${p.keyword}) با ${p.keywordCount} کلمه باید به "${page.title}" با ${page.keywordCount} کلمه لینک دهد`
              });
            }
          }
        }
      });
      return missing;
    },
    checkThematicRelation(keyword1, keyword2) {
      if (!keyword1 || !keyword2) return { isRelated: false, commonWords: [], type: 'بدون ارتباط' };
      const clean1 = this.removeStopWords(keyword1).join(' ');
      const clean2 = this.removeStopWords(keyword2).join(' ');
      if (!clean1 || !clean2) return { isRelated: false, commonWords: [], type: 'بدون کلمه کلیدی' };
      const words1 = clean1.split(' ');
      const words2 = clean2.split(' ');
      const allWordsExist = words2.every(word => words1.includes(word));
      if (allWordsExist) {
        const commonWords = words2.filter(word => words1.includes(word));
        return { isRelated: true, commonWords, type: `مرتبط (${commonWords.length} کلمه مشترک)` };
      }
      return { isRelated: false, commonWords: [], type: 'بدون ارتباط کامل' };
    },
    removeStopWords(text) {
      if (!text) return [];
      return text.split(/\s+/).filter(w => w.length > 0).filter(word => {
        const clean = word.replace(/[^آ-یa-zA-Z]/g, '').toLowerCase();
        return !this.stopWords.includes(clean) && clean.length > 0;
      });
    },
    countKeywords(text) {
      if (!text) return 0;
      return text.split(/\s+/).filter(w => w.length > 0).filter(word => {
        const clean = word.replace(/[^آ-یa-zA-Z]/g, '').toLowerCase();
        return !this.stopWords.includes(clean) && clean.length > 0;
      }).length;
    },
    showSuggestion(page, cluster) {
      let problem = '', solution = '';
      if (!page.isCorrect) {
        problem = `صفحه "${page.title}" (${page.keywordCount} کلمه) به "${cluster.title}" (${cluster.keywordCount} کلمه) لینک داده.`;
        solution = `صفحات با کلمات بیشتر باید به صفحات با کلمات کمتر لینک دهند.`;
      } else if (page.levelDifference > 1) {
        problem = `پرش ${page.levelDifference} سطحی از "${page.title}" به "${cluster.title}".`;
        solution = `بهتر است مسیر لایه‌ای استفاده شود: ${page.keywordCount} → ${page.keywordCount - 1} → ... → ${cluster.keywordCount}`;
      }
      this.selectedSuggestion = { problem, solution, suggestedAnchor: cluster.title, example: `<a href="${cluster.url}">${cluster.title}</a>` };
      this.showModal = true;
    },
    showMissingSuggestion(missing) {
      this.selectedMissing = missing;
      this.showMissingModal = true;
    },
    copySuggestion() {
      if (!this.selectedMissing) return;
      const text = `برای اطلاعات بیشتر در مورد ${this.selectedMissing.suggestedAnchor}، مقاله جامع ما را مطالعه کنید.`;
      this.copyText(text, 'متن کپی شد');
    },
    copyLinkSuggestion(missing) {
      const text = `برای اطلاعات بیشتر در مورد ${missing.suggestedAnchor}، مقاله جامع ما را مطالعه کنید.`;
      this.copyText(text, 'متن لینک کپی شد');
    },
    copyText(text, msg) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => this.showToast(msg));
      } else {
        const ta = document.createElement('textarea');
        ta.value = text;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        this.showToast(msg);
      }
    },
    getHealthLabel(health) {
      return { healthy: 'سالم', warning: 'هشدار', unhealthy: 'مشکل‌دار' }[health] || health;
    },

    /* =====================================================================
     * v2.0 — DASHBOARD / TAB HELPER METHODS
     * =================================================================== */
    scoreClass(score) {
      if (score >= 70) return 'tcla-score--good';
      if (score >= 40) return 'tcla-score--mid';
      return 'tcla-score--bad';
    },
    getSourceByUrl(url) {
      const node = this.graph.nodes[url];
      return node ? node.source : null;
    },
    showOpportunityDetail(op) {
      this.selectedOpportunity = op;
      this.showOpportunityModal = true;
    },
    copyOpportunitySuggestion() {
      if (!this.selectedOpportunity) return;
      this.copyText(this.selectedOpportunity.suggestedSentence, 'متن پیشنهادی کپی شد');
    }
  }
};
</script>


<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Vazirmatn:wght@300;400;500;600;700&display=swap');

/* =============================================
   DESIGN TOKENS
   ============================================= */
.tcla {
  --c-bg: #f5f3ef;
  --c-surface: #ffffff;
  --c-surface-alt: #faf9f7;
  --c-border: #e8e5df;
  --c-border-light: #f0ede8;
  --c-text: #2c2a26;
  --c-text-secondary: #6b6760;
  --c-text-muted: #9d9890;
  --c-accent: #4a6cf7;
  --c-accent-light: #eef1fe;
  --c-success: #22c55e;
  --c-success-light: #ecfdf5;
  --c-success-border: #bbf7d0;
  --c-danger: #ef4444;
  --c-danger-light: #fef2f2;
  --c-danger-border: #fecaca;
  --c-warning: #f59e0b;
  --c-warning-light: #fffbeb;
  --c-warning-border: #fde68a;
  --c-blue: #3b82f6;
  --c-blue-light: #eff6ff;
  --c-blue-border: #bfdbfe;
  --radius-sm: 6px;
  --radius-md: 10px;
  --radius-lg: 14px;
  --radius-xl: 18px;
  --shadow-sm: 0 1px 2px rgba(44,42,38,0.04);
  --shadow-md: 0 2px 8px rgba(44,42,38,0.06), 0 1px 2px rgba(44,42,38,0.04);
  --shadow-lg: 0 4px 20px rgba(44,42,38,0.08), 0 2px 6px rgba(44,42,38,0.04);
  --shadow-xl: 0 8px 40px rgba(44,42,38,0.12);

  font-family: 'Vazirmatn', sans-serif;
  direction: rtl;
  text-align: right;
  background: var(--c-bg);
  color: var(--c-text);
  padding: 24px;
  min-height: 100vh;
}

/* =============================================
   HEADER
   ============================================= */
.tcla-header {
  background: var(--c-surface);
  border-radius: var(--radius-xl);
  padding: 28px 32px;
  margin-bottom: 20px;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--c-border-light);
}

.tcla-header__top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 28px;
}

.tcla-header__title {
  font-size: 1.35rem;
  font-weight: 700;
  color: var(--c-text);
  margin: 0 0 4px 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.tcla-header__icon {
  font-size: 1.3rem;
}

.tcla-header__subtitle {
  font-size: 0.82rem;
  color: var(--c-text-muted);
  margin: 0;
  padding-right: 36px;
}

.tcla-header__badges {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}

/* Badges */
.tcla-badge {
  display: inline-flex;
  align-items: center;
  padding: 5px 14px;
  border-radius: 100px;
  font-size: 0.78rem;
  font-weight: 600;
  white-space: nowrap;
}

.tcla-badge--blue { background: var(--c-accent-light); color: var(--c-accent); }
.tcla-badge--green { background: var(--c-success-light); color: #16a34a; }
.tcla-badge--red { background: var(--c-danger-light); color: var(--c-danger); }
.tcla-badge--amber { background: var(--c-warning-light); color: #d97706; }

/* =============================================
   STATS
   ============================================= */
.tcla-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
}

.tcla-stat {
  background: var(--c-surface-alt);
  border-radius: var(--radius-md);
  padding: 18px 20px;
  border: 1px solid var(--c-border-light);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.tcla-stat:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

.tcla-stat__value {
  font-size: 1.9rem;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 4px;
}

.tcla-stat--success .tcla-stat__value { color: var(--c-success); }
.tcla-stat--danger .tcla-stat__value { color: var(--c-danger); }
.tcla-stat--warning .tcla-stat__value { color: var(--c-warning); }
.tcla-stat--neutral .tcla-stat__value { color: var(--c-text-secondary); }

.tcla-stat__label {
  font-size: 0.78rem;
  color: var(--c-text-muted);
  margin-bottom: 12px;
  font-weight: 500;
}

.tcla-stat__bar {
  height: 4px;
  background: var(--c-border-light);
  border-radius: 100px;
  overflow: hidden;
}

.tcla-stat__bar-fill {
  height: 100%;
  border-radius: 100px;
  transition: width 0.8s cubic-bezier(0.22, 1, 0.36, 1);
}

.tcla-stat--success .tcla-stat__bar-fill { background: var(--c-success); }
.tcla-stat--danger .tcla-stat__bar-fill { background: var(--c-danger); }
.tcla-stat--warning .tcla-stat__bar-fill { background: var(--c-warning); }
.tcla-stat--neutral .tcla-stat__bar-fill { background: var(--c-text-muted); }
.tcla-stat__bar-fill--full { width: 100% !important; }

/* =============================================
   FILTERS
   ============================================= */
.tcla-filters {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.tcla-filter {
  flex: 1;
  min-width: 160px;
}

.tcla-filter--search {
  flex: 1.5;
}

.tcla-filter__label {
  display: block;
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--c-text-muted);
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.tcla-filter__select {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid var(--c-border);
  border-radius: var(--radius-md);
  background: var(--c-surface);
  font-family: inherit;
  font-size: 0.85rem;
  color: var(--c-text);
  appearance: none;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%239d9890' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: 14px center;
  padding-left: 32px;
}

.tcla-filter__select:focus {
  outline: none;
  border-color: var(--c-accent);
  box-shadow: 0 0 0 3px rgba(74, 108, 247, 0.1);
}

.tcla-search {
  position: relative;
}

.tcla-search__icon {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--c-text-muted);
  pointer-events: none;
}

.tcla-search__input {
  width: 100%;
  padding: 10px 14px;
  padding-right: 40px;
  border: 1px solid var(--c-border);
  border-radius: var(--radius-md);
  background: var(--c-surface);
  font-family: inherit;
  font-size: 0.85rem;
  color: var(--c-text);
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;
}

.tcla-search__input::placeholder {
  color: var(--c-text-muted);
}

.tcla-search__input:focus {
  outline: none;
  border-color: var(--c-accent);
  box-shadow: 0 0 0 3px rgba(74, 108, 247, 0.1);
}

/* =============================================
   EMPTY STATE
   ============================================= */
.tcla-empty {
  text-align: center;
  padding: 60px 20px;
  background: var(--c-surface);
  border-radius: var(--radius-xl);
  border: 1px dashed var(--c-border);
}

.tcla-empty__icon {
  font-size: 3rem;
  margin-bottom: 12px;
}

.tcla-empty__text {
  font-size: 1rem;
  font-weight: 600;
  color: var(--c-text-secondary);
  margin: 0 0 4px 0;
}

.tcla-empty__hint {
  font-size: 0.82rem;
  color: var(--c-text-muted);
  margin: 0;
}

/* =============================================
   CLUSTERS
   ============================================= */
.tcla-clusters {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.tcla-cluster {
  background: var(--c-surface);
  border-radius: var(--radius-lg);
  border: 1px solid var(--c-border-light);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  animation: clusterSlideUp 0.4s ease forwards;
  opacity: 0;
  transition: box-shadow 0.25s ease;
}

.tcla-cluster:hover {
  box-shadow: var(--shadow-md);
}

.tcla-cluster--healthy { border-right: 4px solid var(--c-success); }
.tcla-cluster--warning { border-right: 4px solid var(--c-warning); }
.tcla-cluster--unhealthy { border-right: 4px solid var(--c-danger); }

@keyframes clusterSlideUp {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Cluster Header */
.tcla-cluster__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 24px;
  cursor: pointer;
  transition: background 0.15s;
  user-select: none;
}

.tcla-cluster__header:hover {
  background: var(--c-surface-alt);
}

.tcla-cluster__header-right {
  display: flex;
  align-items: center;
  gap: 14px;
}

.tcla-cluster__folder {
  font-size: 1.5rem;
  flex-shrink: 0;
}

.tcla-cluster__title {
  font-size: 0.95rem;
  font-weight: 600;
  margin: 0 0 4px 0;
  color: var(--c-text);
}

.tcla-cluster__keyword-tag {
  font-weight: 400;
  color: var(--c-text-muted);
  font-size: 0.82rem;
}

.tcla-cluster__meta {
  font-size: 0.75rem;
  color: var(--c-text-muted);
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.tcla-cluster__meta-sep {
  color: var(--c-border);
  margin: 0 2px;
}

.tcla-cluster__health-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  margin-left: 4px;
}

.tcla-cluster__health-dot--healthy { background: var(--c-success); }
.tcla-cluster__health-dot--warning { background: var(--c-warning); }
.tcla-cluster__health-dot--unhealthy { background: var(--c-danger); }

.tcla-cluster__chevron {
  transition: transform 0.25s ease;
  color: var(--c-text-muted);
  flex-shrink: 0;
}

.tcla-cluster__chevron--open {
  transform: rotate(180deg);
}

/* Cluster Body */
.tcla-cluster__body {
  padding: 0 24px 24px;
  border-top: 1px solid var(--c-border-light);
}

/* Rule Box */
.tcla-rule {
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--c-accent-light);
  border-radius: var(--radius-sm);
  padding: 12px 16px;
  margin: 18px 0;
  font-size: 0.8rem;
  color: var(--c-accent);
  border: 1px solid rgba(74, 108, 247, 0.12);
}

.tcla-rule__icon { font-size: 1rem; flex-shrink: 0; }

.tcla-rule__text { flex: 1; line-height: 1.6; }

.tcla-rule__check {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--c-success);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: 700;
  flex-shrink: 0;
}

.tcla-rule__warn {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--c-warning);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: 700;
  flex-shrink: 0;
}

/* Section */
.tcla-section {
  margin-top: 22px;
}

.tcla-section__title {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--c-text-secondary);
  margin: 0 0 10px 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.tcla-section__title--err { color: var(--c-danger); }
.tcla-section__title--warn { color: var(--c-warning); }

/* Linked Pages */
.tcla-linked-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.tcla-linked {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--c-border-light);
  transition: background 0.15s;
  gap: 12px;
  flex-wrap: wrap;
}

.tcla-linked--ok {
  background: var(--c-success-light);
  border-color: var(--c-success-border);
}

.tcla-linked--warn {
  background: var(--c-warning-light);
  border-color: var(--c-warning-border);
}

.tcla-linked--err {
  background: var(--c-danger-light);
  border-color: var(--c-danger-border);
}

.tcla-linked__left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex: 1;
}

.tcla-linked__status-icon {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.72rem;
  font-weight: 700;
  flex-shrink: 0;
  color: white;
}

.tcla-linked--ok .tcla-linked__status-icon { background: var(--c-success); }
.tcla-linked--warn .tcla-linked__status-icon { background: var(--c-warning); }
.tcla-linked--err .tcla-linked__status-icon { background: var(--c-danger); }

.tcla-linked__info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.tcla-linked__title {
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--c-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tcla-linked__anchor {
  font-size: 0.72rem;
  color: var(--c-text-muted);
}

.tcla-linked__right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  flex-wrap: wrap;
}

.tcla-linked__kw-count {
  font-size: 0.72rem;
  color: var(--c-text-muted);
  background: var(--c-surface-alt);
  padding: 2px 8px;
  border-radius: 100px;
  border: 1px solid var(--c-border-light);
}

.tcla-linked__direction {
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--c-text-secondary);
  font-family: monospace;
  direction: ltr;
}

/* Tags */
.tcla-tag {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 100px;
  font-size: 0.7rem;
  font-weight: 600;
  white-space: nowrap;
}

.tcla-tag--ok { background: var(--c-success-light); color: #16a34a; border: 1px solid var(--c-success-border); }
.tcla-tag--warn { background: var(--c-warning-light); color: #d97706; border: 1px solid var(--c-warning-border); }
.tcla-tag--err { background: var(--c-danger-light); color: var(--c-danger); border: 1px solid var(--c-danger-border); }
.tcla-tag--blue { background: var(--c-blue-light); color: var(--c-blue); border: 1px solid var(--c-blue-border); }
.tcla-tag--green { background: var(--c-success-light); color: #16a34a; border: 1px solid var(--c-success-border); }

/* Buttons */
.tcla-btn-link {
  background: none;
  border: none;
  color: var(--c-accent);
  font-family: inherit;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: var(--radius-sm);
  transition: background 0.15s;
}

.tcla-btn-link:hover {
  background: var(--c-accent-light);
}

.tcla-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  border-radius: var(--radius-md);
  font-family: inherit;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.tcla-btn--primary {
  background: var(--c-accent);
  color: white;
}

.tcla-btn--primary:hover {
  background: #3b5de7;
  box-shadow: var(--shadow-md);
}

.tcla-btn--outline {
  background: var(--c-surface);
  color: var(--c-text-secondary);
  border: 1px solid var(--c-border);
}

.tcla-btn--outline:hover {
  border-color: var(--c-accent);
  color: var(--c-accent);
  background: var(--c-accent-light);
}

.tcla-btn--sm {
  padding: 6px 14px;
  font-size: 0.75rem;
}

/* Errors */
.tcla-errors {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.tcla-error-item {
  background: var(--c-danger-light);
  border: 1px solid var(--c-danger-border);
  border-radius: var(--radius-sm);
  padding: 10px 14px;
  font-size: 0.8rem;
  color: #b91c1c;
  line-height: 1.6;
}

/* Missing Links */
.tcla-missing-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.tcla-missing {
  background: var(--c-warning-light);
  border: 1px solid var(--c-warning-border);
  border-radius: var(--radius-md);
  padding: 16px 18px;
}

.tcla-missing__top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  flex-wrap: wrap;
}

.tcla-missing__info {
  flex: 1;
  min-width: 0;
}

.tcla-missing__reason {
  font-size: 0.82rem;
  color: var(--c-text);
  display: block;
  margin-bottom: 6px;
  line-height: 1.6;
}

.tcla-missing__tags {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.tcla-common-words {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.tcla-common-words__label {
  font-size: 0.72rem;
  color: var(--c-text-muted);
}

.tcla-word-chip {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  background: var(--c-surface);
  border: 1px solid var(--c-border);
  border-radius: 100px;
  font-size: 0.72rem;
  color: var(--c-text-secondary);
  font-weight: 500;
}

/* Suggestion Box */
.tcla-suggestion-box {
  margin-top: 14px;
  background: var(--c-surface);
  border: 1px solid var(--c-border);
  border-radius: var(--radius-md);
  overflow: hidden;
}

.tcla-suggestion-box__header {
  background: var(--c-accent-light);
  padding: 10px 16px;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--c-accent);
  border-bottom: 1px solid rgba(74, 108, 247, 0.1);
}

.tcla-suggestion-box__body {
  padding: 14px 16px;
  font-size: 0.82rem;
  line-height: 1.7;
  color: var(--c-text-secondary);
}

.tcla-suggestion-box__body p { margin: 0 0 8px; }
.tcla-suggestion-box__body code {
  background: var(--c-success-light);
  color: #16a34a;
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 0.8rem;
}

.tcla-suggestion-box__example {
  color: var(--c-text-muted) !important;
  font-size: 0.78rem !important;
  font-style: italic;
}

.tcla-suggestion-box__example a {
  color: var(--c-accent);
  text-decoration: underline;
}

/* =============================================
   MODAL
   ============================================= */
.tcla-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(44, 42, 38, 0.35);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.tcla-modal {
  background: var(--c-surface);
  border-radius: var(--radius-xl);
  width: 100%;
  max-width: 600px;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: var(--shadow-xl);
  animation: modalSlideUp 0.25s ease;
  border: 1px solid var(--c-border-light);
}

@keyframes modalSlideUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.tcla-modal__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid var(--c-border-light);
}

.tcla-modal__header h3 {
  font-size: 1rem;
  font-weight: 700;
  margin: 0;
  color: var(--c-text);
}

.tcla-modal__close {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: var(--c-surface-alt);
  color: var(--c-text-muted);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  transition: all 0.15s;
}

.tcla-modal__close:hover {
  background: var(--c-danger-light);
  color: var(--c-danger);
}

.tcla-modal__body {
  padding: 24px;
  overflow-y: auto;
  flex: 1;
}

.tcla-modal__section {
  margin-bottom: 20px;
}

.tcla-modal__section:last-child {
  margin-bottom: 0;
}

.tcla-modal__section h4 {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--c-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin: 0 0 8px 0;
}

.tcla-modal__section p {
  margin: 0;
  font-size: 0.85rem;
  line-height: 1.7;
}

.tcla-modal__problem { color: var(--c-danger); }
.tcla-modal__solution { color: #16a34a; }
.tcla-modal__warn { color: #d97706; }
.tcla-modal__muted { color: var(--c-text-muted); font-size: 0.8rem !important; }

.tcla-modal__code-block {
  background: var(--c-surface-alt);
  border: 1px solid var(--c-border);
  border-radius: var(--radius-sm);
  padding: 12px 16px;
  font-family: 'DM Mono', 'Courier New', monospace;
  font-size: 0.82rem;
  color: var(--c-text);
  direction: ltr;
  text-align: left;
  word-break: break-all;
}

.tcla-modal__code-block--dark {
  background: #1e1e2e;
  color: #cdd6f4;
  border-color: #313244;
}

.tcla-modal__example-block {
  background: var(--c-accent-light);
  border: 1px solid rgba(74, 108, 247, 0.15);
  border-radius: var(--radius-sm);
  padding: 12px 16px;
  font-size: 0.85rem;
  color: var(--c-accent);
  direction: ltr;
  text-align: left;
}

.tcla-modal__highlight {
  background: var(--c-success-light);
  border: 1px solid var(--c-success-border);
  border-radius: var(--radius-sm);
  padding: 12px 16px;
  font-size: 0.85rem;
  line-height: 1.7;
  color: var(--c-text);
}

.tcla-modal__highlight code {
  background: rgba(22, 163, 74, 0.1);
  color: #16a34a;
  padding: 1px 6px;
  border-radius: 4px;
}

.tcla-modal__highlight--blue {
  background: var(--c-accent-light);
  border-color: rgba(74, 108, 247, 0.2);
}

.tcla-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1px solid var(--c-border-light);
}

/* =============================================
   TOAST
   ============================================= */
.tcla-toast {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--c-text);
  color: white;
  padding: 12px 24px;
  border-radius: 100px;
  font-size: 0.85rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: var(--shadow-lg);
  z-index: 99999;
}

.tcla-toast__icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--c-success);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.65rem;
  font-weight: 700;
}

.toast-enter-active { animation: toastIn 0.3s ease; }
.toast-leave-active { animation: toastOut 0.25s ease; }

@keyframes toastIn {
  from { opacity: 0; transform: translateX(-50%) translateY(20px); }
  to { opacity: 1; transform: translateX(-50%) translateY(0); }
}

@keyframes toastOut {
  from { opacity: 1; transform: translateX(-50%) translateY(0); }
  to { opacity: 0; transform: translateX(-50%) translateY(20px); }
}

/* =============================================
   RESPONSIVE
   ============================================= */
@media (max-width: 900px) {
  .tcla { padding: 16px; }
  .tcla-stats { grid-template-columns: repeat(2, 1fr); }
  .tcla-header { padding: 20px; }
  .tcla-header__top { flex-direction: column; }
  .tcla-cluster__header { padding: 14px 16px; }
  .tcla-cluster__body { padding: 0 16px 16px; }
  .tcla-linked { flex-direction: column; align-items: flex-start; }
  .tcla-linked__right { width: 100%; justify-content: flex-end; }
}

@media (max-width: 600px) {
  .tcla-stats { grid-template-columns: 1fr 1fr; gap: 8px; }
  .tcla-filters { flex-direction: column; }
  .tcla-filter { min-width: 100%; }
  .tcla-missing__top { flex-direction: column; }
}

/* =============================================
   v2.0 — TAB NAVIGATION
   ============================================= */
.tcla-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  background: var(--c-surface);
  border: 1px solid var(--c-border-light);
  border-radius: var(--radius-lg);
  padding: 6px;
  margin-bottom: 20px;
  box-shadow: var(--shadow-sm);
}

.tcla-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 14px;
  border: none;
  background: transparent;
  border-radius: var(--radius-md);
  font-family: inherit;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--c-text-secondary);
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  white-space: nowrap;
}

.tcla-tab:hover { background: var(--c-surface-alt); color: var(--c-text); }
.tcla-tab--active { background: var(--c-accent); color: #fff; }
.tcla-tab__icon { font-size: 0.95rem; }

.tcla-tab__badge {
  background: rgba(255,255,255,0.25);
  border-radius: 100px;
  padding: 1px 7px;
  font-size: 0.68rem;
  margin-right: 2px;
}

.tcla-tab:not(.tcla-tab--active) .tcla-tab__badge {
  background: var(--c-accent-light);
  color: var(--c-accent);
}

/* =============================================
   v2.0 — DASHBOARD CARDS
   ============================================= */
.tcla-dashboard { margin-bottom: 20px; }

.tcla-cards-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-bottom: 20px;
}

.tcla-card {
  background: var(--c-surface);
  border: 1px solid var(--c-border-light);
  border-radius: var(--radius-lg);
  padding: 18px 20px;
  box-shadow: var(--shadow-sm);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.tcla-card:hover { transform: translateY(-1px); box-shadow: var(--shadow-md); }
.tcla-card__icon { font-size: 1.3rem; margin-bottom: 6px; }
.tcla-card__value { font-size: 1.6rem; font-weight: 700; color: var(--c-text); line-height: 1; margin-bottom: 4px; }
.tcla-card__label { font-size: 0.75rem; color: var(--c-text-muted); font-weight: 500; }
.tcla-card--warn .tcla-card__value { color: var(--c-warning); }
.tcla-card--danger .tcla-card__value { color: var(--c-danger); }

/* =============================================
   v2.0 — GENERIC PANELS (used by every new tab)
   ============================================= */
.tcla-section-tab { display: flex; flex-direction: column; gap: 16px; margin-bottom: 20px; }

.tcla-panel {
  background: var(--c-surface);
  border: 1px solid var(--c-border-light);
  border-radius: var(--radius-lg);
  padding: 20px 22px;
  box-shadow: var(--shadow-sm);
  margin-bottom: 16px;
}

.tcla-panel__title {
  font-size: 0.92rem;
  font-weight: 700;
  color: var(--c-text);
  margin: 0 0 14px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.tcla-empty-inline {
  text-align: center;
  padding: 24px;
  color: var(--c-text-muted);
  font-size: 0.85rem;
}

/* Score table (dashboard top pages) */
.tcla-score-table { display: flex; flex-direction: column; gap: 2px; font-size: 0.8rem; }
.tcla-score-row {
  display: grid;
  grid-template-columns: 2fr repeat(6, 1fr);
  align-items: center;
  gap: 8px;
  padding: 10px 8px;
  border-bottom: 1px solid var(--c-border-light);
  text-align: center;
}
.tcla-score-row--head { font-weight: 700; color: var(--c-text-muted); font-size: 0.72rem; text-transform: uppercase; }
.tcla-score-row__title { text-align: right; font-weight: 600; color: var(--c-text); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

.tcla-score-pill {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 100px;
  font-weight: 700;
  font-size: 0.75rem;
}
.tcla-score--good { background: var(--c-success-light); color: #16a34a; }
.tcla-score--mid { background: var(--c-warning-light); color: #d97706; }
.tcla-score--bad { background: var(--c-danger-light); color: var(--c-danger); }

.tcla-score-bar-track {
  height: 6px;
  background: var(--c-border-light);
  border-radius: 100px;
  overflow: hidden;
  margin: 8px 0;
}
.tcla-score-bar-fill { height: 100%; border-radius: 100px; }
.tcla-score-bar-fill.tcla-score--good { background: var(--c-success); }
.tcla-score-bar-fill.tcla-score--mid { background: var(--c-warning); }
.tcla-score-bar-fill.tcla-score--bad { background: var(--c-danger); }

.tcla-authority-badge {
  font-size: 0.78rem;
  font-weight: 700;
  padding: 4px 12px;
  border-radius: 100px;
}

.tcla-cluster-authority__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Hub / spoke / anchor / gap cards */
.tcla-hub-card {
  border: 1px solid var(--c-border-light);
  border-radius: var(--radius-md);
  padding: 14px 16px;
  margin-bottom: 10px;
  background: var(--c-surface-alt);
}
.tcla-hub-card__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 6px;
}
.tcla-hub-card__meta {
  font-size: 0.76rem;
  color: var(--c-text-muted);
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
}

.tcla-chip-list { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 8px; }

.tcla-tag--purple { background: #f4f4f5; color: #111111; }

/* =============================================
   v2.0 — VISUAL GRAPH (SVG)
   ============================================= */
.tcla-graph-svg {
  width: 100%;
  height: auto;
  font-family: 'Vazirmatn', sans-serif;
}

.tcla-graph-edge {
  stroke: var(--c-border);
  stroke-width: 1.5;
}
.tcla-graph-edge--missing {
  stroke: var(--c-danger);
  stroke-dasharray: 4 3;
}

.tcla-graph-node { stroke: #fff; stroke-width: 2; }
.tcla-graph-node--hub { fill: var(--c-accent); }
.tcla-graph-node--spoke { fill: #16a34a; }
.tcla-graph-node--sibling { fill: var(--c-warning); }
.tcla-graph-node--orphan { fill: var(--c-danger); }
.tcla-graph-node--deadend { fill: var(--c-text-muted); }

.tcla-graph-label {
  font-size: 10px;
  fill: var(--c-text-secondary);
  text-anchor: middle;
}

.tcla-graph-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  align-items: center;
}
.tcla-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.8rem;
  color: var(--c-text-secondary);
}
.tcla-legend-item i.tcla-graph-node {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  stroke: none;
}

/* =============================================
   v2.0 — RESPONSIVE
   ============================================= */
@media (max-width: 900px) {
  .tcla-cards-grid { grid-template-columns: repeat(2, 1fr); }
  .tcla-score-row { grid-template-columns: 2fr repeat(3, 1fr); font-size: 0.72rem; }
  .tcla-score-row > span:nth-child(n+5) { display: none; }
}

@media (max-width: 600px) {
  .tcla-tabs { overflow-x: auto; flex-wrap: nowrap; }
  .tcla-cards-grid { grid-template-columns: 1fr 1fr; }
  .tcla-hub-card__top { flex-direction: column; align-items: flex-start; }
}
</style>